// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-05T18:34:39.025Z
// Property: Ellison at The Preserve (ID: 6767906449167904)
// Collections: 42 amenities, 16 floorplans (live), 87 photos, 71 POIs, 4 reviews, 11 virtual tours, 7 office hours, 2 fees (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162393",
  "multihub_property_id": "6767906449167904",
  "property_external_id": "100185812",
  "property_zillow_url": "https://www.zillow.com/apartments/asheville-nc/ellison-at-the-preserve/CpRDtn/",
  "property_apartments_url": "https://www.apartments.com/ellison-at-the-preserve-asheville-nc/g23rk3x/",
  "property_google_business_url": "https://www.google.com/maps/place/?q=place_id:ChIJn_gXgf7zWYgRZyj903_6h7U",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": "Entrata",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ellison-at-the-preserve",
  "property_name": "Ellison at The Preserve",
  "property_website_url": "https://www.ellisonpreserve.com/",
  "property_domain": "https://www.ellisonpreserve.com/",
  "property_address": "375 Spg Blf Ln",
  "property_full_address": "375 Spg Blf Ln, Asheville, NC 28803",
  "property_address_1": "375 Spg Blf Ln",
  "property_address_2": null,
  "property_address_city": "Asheville",
  "property_address_state": "NC",
  "property_address_zip_full": "28803",
  "property_address_zip": "28803",
  "property_address_country": "US",
  "property_address_county": "Buncombe County",
  "property_neighborhood_address": "Blue Ridge",
  "property_address_latitude": "35.5187455",
  "property_address_longitude": "-82.5189613",
  "property_email": "ellisonatthepreserve@galleryresidential.com",
  "property_phone": "828-810-0442",
  "property_call_tracking_phone": "(704) 828-0522",
  "property_company_name": "Gallery Residential",
  "property_company_url": "https://www.galleryresidential.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "<p><strong>Mountain-view living, polished for everyday ease.</strong> Explore open-concept studio to three-bedroom apartments with elevated finishes, scenic outdoor spaces, and resort-style community comforts—then <a href=\"/schedule-a-tour\">schedule your visit</a> to experience Ellison at The Preserve.</p>",
  "property_long_description": "Discover Ellison at the Preserve, offering brand-new, pet-friendly luxury apartments for rent in a premier South Asheville, NC location. Our community presents thoughtfully designed 1, 2, and 3-bedroom apartment homes with breathtaking Blue Ridge Mountain views and high-end finishes. Experience resort-style living with amenities like a heated saltwater pool, a modern 24/7 fitness center, and a bark park with a pet spa. Interiors boast sophisticated features including quartz countertops, stainless steel appliances, and in-unit washer/dryer. Our 28803 location near Biltmore Forest provides quick access to I-26 and I-40, placing you near the best of Asheville, including Biltmore Park Town Square.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1a828-4716-72dc-9296-e340d5a2c015.webp",
  "property_featured_image_media": {
    "alt_text": "Modern shower with white subway tiles and black fixtures, adjacent to a bedroom.",
    "public_id": "01a1a828-4716-72dc-9296-e340d5a2c015",
    "storage_key": "property/6767906449167904/01a1a828-4716-72dc-9296-e340d5a2c015.webp",
    "width": 3072,
    "height": 2051
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "315",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": "5",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "88.21656050955414",
  "property_admin_fee": "$250",
  "property_application_fee": "$75",
  "property_fees_deposit_info": "Amenity fee: $65/month. Security deposit: $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "1",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": "120",
  "property_pet_restrictions": "Dogs and cats allowed. Up to 3 pets per apartment. Maximum dog weight: 120 lbs; maximum cat weight: 50 lbs.",
  "property_pet_policy_description": "Pet fee: $1.00 (non-refundable). Monthly pet rent: $25.00/month.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://ellisonpreservenc.prospectportal.com/asheville/ellison-at-the-preserve",
  "property_resident_portal_url": "https://ellisonpreservenc.residentportal.com/auth",
  "property_apply_now_url": "https://ellisonpreservenc.prospectportal.com/Apartments/module/application_authentication/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17956-cfb2-757c-b069-69549fbc5ac7.webp",
  "property_primary_logo_media": {
    "alt_text": "Ellison at the Preserve logo by Flournoy Development",
    "public_id": "01a17956-cfb2-757c-b069-69549fbc5ac7",
    "storage_key": "property/6767906449167904/01a17956-cfb2-757c-b069-69549fbc5ac7.webp",
    "width": 1050,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-136d-7029-a56c-90ce47120186.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a1795e-136d-7029-a56c-90ce47120186",
    "storage_key": "property/6767906449167904/01a1795e-136d-7029-a56c-90ce47120186.webp",
    "width": 1050,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795d-b996-72dc-982e-4ca1beb4a6a0.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a1795d-b996-72dc-982e-4ca1beb4a6a0",
    "storage_key": "property/6767906449167904/01a1795d-b996-72dc-982e-4ca1beb4a6a0.webp",
    "width": 1050,
    "height": 150
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162393/019f4270-24f6-709b-b2c5-c205bf400083.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162393/019f426f-bfed-731a-a27d-d31038c4cea2.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "624 - 1348",
  "property_sqft_min": "624",
  "property_sqft_max": "1348",
  "property_price_range": "$1580 - $2775",
  "property_price_min": "1580",
  "property_price_max": "2775",
  "property_available_units": 37,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61564168795828",
  "property_instagram_url": "https://www.instagram.com/liveellisonpreserve",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJn_gXgf7zWYgRZyj903_6h7U",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ellison at The Preserve",
  "property_home_romance_title": "Embrace Happiness in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, elevated.</strong> Ellison at The Preserve pairs polished apartment finishes with amenities that work hard, from a co-working lounge with private work spaces to a refreshment bar, grab-and-go market, fitness and wellness center, and heated saltwater pool.</p><p>Outdoors, courtyard grills, fire pits, covered pergolas, and open greenspace create more room to unwind, while a pet spa, EV charging, bike storage, car care center, and package room add convenience from every angle.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore studio, one-, two-, and three-bedroom apartments in Asheville with open-concept kitchens, quartz countertops, stainless steel appliances, matte black finishes, and large islands in select homes. High ceilings, in-home washer and dryer, keyless entry, walk-in closets, and select balconies or patios bring polished ease to every floor plan preview.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a glimpse of Ellison at The Preserve.</strong> Browse mountain-framed views, quartz-topped kitchens with oversized islands, matte black accents, and bright interiors that extend to select balconies or patios. Then preview the heated saltwater pool, covered pergolas, co-working lounge, art studio, fitness spaces, coffee bar, and pet spa—each photo capturing a sharper sense of everyday Asheville living.</p>",
  "property_home_neighborhood_blurb": "<p><strong>South Asheville puts the best of both worlds on the map.</strong> At Ellison at The Preserve, Blue Ridge foothill views meet Hendersonville Road convenience, with Biltmore Park dining, Parkway overlooks, and The North Carolina Arboretum nearby. ART’s South 6 route, I-26, and I-40 keep Asheville essentials within easy reach—explore the map, then see the location in person.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the details.</strong> Reviews for Ellison at The Preserve call out a welcoming, attentive team, thoughtful design, and an easy sense of connection across the community. Favorites include spacious surroundings, a well-equipped gym, heated pool, and mountain-view sunsets from the balcony. Read the full reviews to see why Ellison’s “genuine warmth” stands out—and why scheduling a tour is such a common next step.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your map to South Asheville.</strong> From Ellison at The Preserve, you’re tucked into Blue Ridge foothill scenery with Hendersonville Road conveniences close by and Asheville’s creative core within easy reach. Grab brunch at Tupelo Honey South Asheville, make dinner plans around 131 MAIN, Nine Mile, or Luella’s at Biltmore Park Town Square, then trade pavement for Parkway overlooks, the Visitor Center at Milepost 384, or garden-and-trail time at The North Carolina Arboretum. ART’s South 6 route along Hendersonville Road connects toward Biltmore Village, Mission Hospital, downtown, and Biltmore Park, while I-26 and I-40 keep regional drives straightforward. Use the map below to explore the everyday stops and weekend-worthy destinations around Ellison—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location feels in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>The details do the heavy lifting.</strong> At Ellison at The Preserve, amenities are designed to make daily routines feel smoother and downtime feel more rewarding in Asheville. Start with coffee at the refreshment bar, pick up essentials from the grab-and-go market, plug into the co-working lounge with private work spaces, or reset in the fitness and wellness center before heading to the heated saltwater pool.</p><p>Outside, courtyard grills, fire pits, covered pergolas, and open greenspace give you more room to unwind, while a pet spa, bike storage, EV charging, car care center, elevator access, conditioned corridors, and a private package room add practical ease. At home, keyless entry, USB outlets, large islands, quartz countertops, walk-in closets, and select balconies or patios keep the finish level just as thoughtful. See the spaces in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for mountain-view living.</strong> Ellison at The Preserve pairs polished studio, one-, two-, and three-bedroom apartments with open-concept design, quartz countertops, keyless entry, and in-home laundry. If this feels like the right fit, apply online today and take the next step toward calling Ellison home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The leasing team at Ellison at The Preserve is here to help you explore mountain-view apartment living in South Asheville, from floor plans and finishes to touring the community. Reach out today and we’ll point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Ellison at The Preserve?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our mountain-view South Asheville apartments. If you need more details or want help choosing your next home, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Find the plan that fits how you want to live.</strong> Browse a thoughtful collection of studio, one-, two-, and three-bedroom apartments in Asheville, from streamlined layouts that keep everything within easy reach to roomier plans with added separation, generous storage, and two-bath convenience. Inside, open-concept kitchens feel polished and practical with quartz countertops, stainless steel appliances, modern pull-out faucets, matte black finishes, and large islands in select homes. High ceilings, in-home washer and dryer, keyless entry, walk-in closets, and private balconies or patios in select layouts add everyday ease without overcomplicating your space. Compare availability, pricing, and layout details, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plans up close.</p>",
  "property_gallery_blurb": "<p><strong>See the view from here.</strong> Browse the photo gallery for a closer look at Ellison at The Preserve, where mountain backdrops frame polished apartment interiors and inviting community spaces. Picture quartz-topped kitchens with large islands and matte black accents, bright living areas that open to balconies or patios in select homes, and clean-lined baths with contemporary finishes.</p><p>Continue through scenes of the heated saltwater pool, outdoor courtyard, covered pergolas, co-working lounge, art studio, fitness spaces, coffee bar, and pet spa—each image helping you imagine how the setting feels day to day in Asheville. When a layout or amenity catches your eye, explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Ellison at The Preserve on the map.</strong><br>See available apartments, mountain-view living, and the South Asheville connections that put Blue Ridge scenery, everyday ease, local dining, creative culture, and Parkway drives within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, gear, and a little post-walk cleanup.</strong> At Ellison at The Preserve, pet-friendly living is built into the daily routine—not treated like an afterthought. Step out for fresh air across the community greenspace, then head to the pet spa/grooming station when muddy paws need a reset.</p><p>Inside, open layouts, walk-in closets, in-home laundry, and select mudroom storage, balconies, or patios help make life with dogs, cats, leashes, toys, and food bins feel more organized. You’re also in Asheville, where mountain air and everyday errands can fit naturally into the same outing. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Ellison works for every pet-friendly routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share the mountain-view lifestyle.</strong> If you love Ellison at The Preserve’s polished apartments, Blue Ridge scenery, and elevated spaces for work, wellness, and downtime, invite a friend to experience it for themselves. Send a referral today and let them discover South Asheville convenience with you.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Ellison at The Preserve.</strong> Sign in to pay rent, submit maintenance requests, and manage your account with ease—so you can get back to enjoying polished mountain-view living, from your open-concept home to the elevated community spaces just beyond your door.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying.</strong> Reviews for Ellison at The Preserve consistently highlight the welcoming team, thoughtful design, and the easy-to-feel sense of connection throughout the community. From warm first tours with Amy and Ashleigh to everyday support from Chloe and the on-site staff, residents describe service that feels personal, professional, and attentive.</p><p>You’ll also see praise for spacious surroundings, standout amenities like the gym and heated pool, and memorable mountain-view moments— including sunset balconies that make evenings feel special. As one reviewer put it, Ellison has a <strong>“genuine warmth”</strong> that shows in the details. Read the reviews below, then see why so many people recommend scheduling a tour.</p>",
  "property_created_at": "1793037002868",
  "property_scheduletour_blurb": "<p><strong>See mountain-view living up close.</strong> Tour polished studio, one-, two-, and three-bedroom apartments with open layouts, quartz countertops, kitchen islands, keyless entry, and private balconies or patios in select homes. Visit Ellison at The Preserve and picture your day from first look to everyday ease.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong> The Ellison at The Preserve leasing team will follow up soon. In the meantime, picture mountain-view living with polished studio, one-, two-, and three-bedroom apartments, elevated finishes, inviting community spaces, and convenient access to Asheville’s everyday ease and Blue Ridge adventure.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the apartments before you arrive.</strong> Start with a self-guided look inside the Ellison at The Preserve homes available to tour online, including Units 1208, 3414, 2411, 3105, 2410, 1417, 1419, 3319, 1410, and 1125. Move through each apartment at your own pace to compare room flow, kitchen placement, closet space, finish details, and the way natural light carries through the layout.</p><p>Use these virtual tours to narrow your search before reviewing <a href=\"/floor-plans\">available floor plans</a> or planning an in-person visit. As you explore, look for the polished touches that define Ellison in Asheville—open-concept living areas, stainless steel appliances, quartz countertops, modern lighting, high ceilings, and select outdoor-view moments. When one feels right, <a href=\"/schedule-a-tour\">schedule a tour</a> to see it up close.</p>",
  "property_copyright": "2026 All Rights Reserved. Ellison at The Preserve",
  "property_seo_title_home": "Ellison at The Preserve |  Apartments in Asheville, NC",
  "property_seo_description_home": "Experience upscale living at Ellison at The Preserve in Asheville, NC! With modern amenities, stunning views, and a vibrant community, your dream home awaits.",
  "property_seo_title_floorplans": "Floor Plans | Asheville, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Ellison at The Preserve in Asheville, NC. Browse studio to three-bedroom floor plans tailored for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Asheville, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience unmatched living at Ellison at The Preserve in Asheville! Enjoy luxurious amenities, spacious layouts, and a vibrant community tailored for you.",
  "property_seo_title_gallery": "Gallery | Apartments in Asheville, NC",
  "property_seo_description_gallery": "Envision your life at Ellison at The Preserve in Asheville, NC. Spacious floor plans, top-tier amenities, and stunning views await. Your new home is waiting!",
  "property_seo_title_virtualtours": "Virtual Tours | Ellison at The Preserve Apartments",
  "property_seo_description_virtualtours": "Step into Ellison at The Preserve in Asheville, NC! Immerse yourself in our virtual tour and experience studio to three-bedroom apartments tailored for you!",
  "property_seo_title_interactivemap": "Interactive Map | Ellison at The Preserve Apartments",
  "property_seo_description_interactivemap": "Find your perfect retreat at Ellison at The Preserve in Asheville, NC. Use our interactive map to explore floor plans, pricing, and your future home!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Asheville, NC",
  "property_seo_description_neighborhood": "Uncover the charm of Asheville at Ellison at The Preserve. Dive into local favorites and discover vibrant adventures just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Ellison at The Preserve",
  "property_seo_description_contact": "Connect with the friendly team at Ellison at The Preserve in Asheville, NC. From studios to three-bedroom layouts, your ideal home awaits! Reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Asheville, NC",
  "property_seo_description_faqs": "Find answers to your burning questions about life at Ellison at The Preserve in Asheville, NC. Your new home awaits—browse our FAQs and discover more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Asheville, NC",
  "property_seo_description_reviews": "Discover life at Ellison at The Preserve in Asheville, NC—spacious apartments, excellent amenities, and glowing reviews await. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Asheville, NC",
  "property_seo_description_applynow": "Discover modern living at Ellison at The Preserve in Asheville, NC. Choose from spacious studios to three-bedrooms. Enjoy luxury amenities—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Ellison at The Preserve",
  "property_seo_description_residentaccess": "Connect with your community at Ellison at The Preserve! Log in to your resident portal for rent payments, maintenance requests, and exclusive updates.",
  "property_seo_title_referafriend": "Refer A Friend | Ellison at The Preserve",
  "property_seo_description_referafriend": "Refer a friend to Ellison at The Preserve in Asheville, NC! Join a community where great friends create lasting memories. Share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ellison at The Preserve",
  "property_seo_description_scheduletour": "Experience upscale living at Ellison at The Preserve in Asheville, NC. Schedule a tour today and envision your vibrant new lifestyle among nature's beauty!",
  "property_seo_title_privacy": "Privacy Policy | Ellison at The Preserve",
  "property_seo_description_privacy": "At Ellison at The Preserve, we prioritize your privacy. Discover how we safeguard your information to enhance your living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Ellison at The Preserve",
  "property_seo_description_accessibility": "At Ellison at The Preserve in Asheville, NC, we're committed to digital inclusion for all. Discover our accessibility features designed with you in mind!",
  "property_seo_title_sitemap": "Sitemap | Ellison at The Preserve",
  "property_seo_description_sitemap": "Navigate our community at Ellison at The Preserve in Asheville, NC. Find amenities, floor plans, and more—all just a click away on our sitemap!",
  "property_seo_title_thankyou": "Thank You | Ellison at The Preserve",
  "property_seo_description_thankyou": "Thank you for reaching out to Ellison at The Preserve in Asheville, NC! Our team will get back to you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Asheville, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793730977537",
  "amenities": [
    {
      "id": "ec_3da6567f8d4e540106761084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:1025",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08bf848c2060fb8aa10baeb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:1033",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ef50a23bd8bb1e9f91582c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:1050",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14cbab718ba9d8093bc44809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:1663",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3b5e033466af68c621114a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:1729",
      "title": "Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a0994362fddc62b672b6965",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:1927",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecaae2f1a36dbf3ab2223edd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:2007",
      "title": "Handicap Accessible",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de9ff7eec7dd09f5b8c7259c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:3145",
      "title": "USB Charging Outlets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4491d978183763cecd29c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:3720",
      "title": "Car Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_373bb4b1e714ab795f023449",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:5003",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4286410f8283f465d982d2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:6733",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae97d1735a0f1d306484da56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:11386",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f6351d836f38d6994f41aaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:12391",
      "title": "EV charging stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d3e03143b06dae6f41d4c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:14453",
      "title": "9 ft. Cielings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef20f9595dce1de2d968e9c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15355",
      "title": "Spacious Pantries",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb8853ddf57e8a1e31d43e1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15357",
      "title": "Modern Faucets with Pull-out Sprayer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f14107dd8193bf4918517f70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15361",
      "title": "Mudroom Storage Area*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ae25d49fe468f9dc51a9d0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15362",
      "title": "Premier Resident Lounge with Gaming and Entertainment Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc0c835356605d7ccb45198e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15432",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5e8e984e36617d4478cfef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15464",
      "title": "Coffee and Refreshment Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a0af954f54ee509baa00738",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15500",
      "title": "Wi-Fi-enabled Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_832c8a0efb667c5858145324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15575",
      "title": "Tile Shower and Tub Surrounds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ccb54aaae834e5dbc7bc64e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15578",
      "title": "Matte Black Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_421277a01e50a9280988e163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15943",
      "title": "Grab-and-Go Market",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eca3ce6333b9c27ad9948c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:15946",
      "title": "Communal Co-working Lounge with Private Work Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eeaf07df3698ac060ece9485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16004",
      "title": "10' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f13312113b3e8d22ad9f2214",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16006",
      "title": "Walk-in Showers*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d6953933deccf60bfeebcfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16073",
      "title": "Expansive Community Greenspace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be40c55c5174c33bcbc04b29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16087",
      "title": "Conditioned Corridors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecbf813f30e98e87cf687c5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16136",
      "title": "Luxury Vinyl Tile Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4b0667109593bf928229c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16137",
      "title": "Large Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_561a497b5b6868e9db039e8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16138",
      "title": "Large Walk-in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24942fcfdb512cc560f5263b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16139",
      "title": "Upgraded Contemporary Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ab5e556974a3c1cbdf3bd41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16140",
      "title": "Heated Saltwater Resort Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e10451d674ad69d5e6f33ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16141",
      "title": "Breathtaking Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c753b13ebea00a96a874b32a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16142",
      "title": "Outdoor Entertainment Courtyard with Fire Pits, Community Grills, Outdoor Gaming and more",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2d5631ee380c27832dfc272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16143",
      "title": "Covered Outdoor Pergolas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b6ffe024173e36c4946fecf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16144",
      "title": "Hobby/Art Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c71b5c9be2ac83ef37145be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16145",
      "title": "Pet Spa/Grooming Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eae301b800083bc1f9c2cce6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16146",
      "title": "State-of-the-art Fitness and Wellness Center with Dedicated Yoga/Meditation Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_718b8cf78cee7cd363cae387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16147",
      "title": "Resident Mail Lounge and Private Package Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7038d0e75a5b2c9d3a1683b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "community:16148",
      "title": "Resident Storage Units Available*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_db26071b-ec23-44e8-94ac-ec1f18f771eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-fe80-737d-b231-c14f66e4c7f1.webp",
      "image_media": {
        "alt_text": "Spacious resident lounge with leather sofas, a pool table, and a bar.",
        "public_id": "01a19e8c-fe80-737d-b231-c14f66e4c7f1",
        "storage_key": "property/6767906449167904/01a19e8c-fe80-737d-b231-c14f66e4c7f1.webp",
        "width": 3072,
        "height": 1998
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish resident lounge, featuring comfortable seating, a billiards table, and a full-service bar area.",
      "link": "",
      "alt_text": "Spacious resident lounge with leather sofas, a pool table, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_620d702d-f7e1-445f-b1cf-d85dadb00c10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-d036-74fe-b78a-54392ae98132.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with balconies and a parking lot under a cloudy sky.",
        "public_id": "01a19e8c-d036-74fe-b78a-54392ae98132",
        "storage_key": "property/6767906449167904/01a19e8c-d036-74fe-b78a-54392ae98132.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Aerial view of contemporary apartment buildings featuring private balconies, ample parking, and lush landscaping, set against a backdrop of rolling hills and a vibrant sky.",
      "link": "",
      "alt_text": "Modern apartment buildings with balconies and a parking lot under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_100a9d09-6e70-4e1b-a779-64704f5104d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-d066-771a-a694-c8967c400624.webp",
      "image_media": {
        "alt_text": "The exterior entrance of The Ellison at The Preserve multifamily property.",
        "public_id": "01a19e8c-d066-771a-a694-c8967c400624",
        "storage_key": "property/6767906449167904/01a19e8c-d066-771a-a694-c8967c400624.webp",
        "width": 3072,
        "height": 1828
      },
      "title": "Community",
      "description": "Welcome to The Ellison at The Preserve, where modern design meets comfortable living. This image showcases the property's inviting exterior entrance.",
      "link": "",
      "alt_text": "The exterior entrance of The Ellison at The Preserve multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17113758-56d4-4a7a-83b9-8106a01837fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-c5e4-7765-8769-93c423b19f8a.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills and dining seating area.",
        "public_id": "01a19e8c-c5e4-7765-8769-93c423b19f8a",
        "storage_key": "property/6767906449167904/01a19e8c-c5e4-7765-8769-93c423b19f8a.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and cookouts in our vibrant community courtyard, featuring state-of-the-art grills and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor grilling area with built-in grills and dining seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac419533-b5ef-4db1-93be-3100fc3aac0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-c456-757f-9045-d543e5c8f575.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with a large island, bar stools, and comfortable seating.",
        "public_id": "01a19e8c-c456-757f-9045-d543e5c8f575",
        "storage_key": "property/6767906449167904/01a19e8c-c456-757f-9045-d543e5c8f575.webp",
        "width": 3072,
        "height": 1921
      },
      "title": "Community",
      "description": "Enjoy our modern and inviting lounge area, perfect for socializing or relaxing. Features a stylish island with bar seating and ample comfortable seating options.",
      "link": "",
      "alt_text": "Spacious lounge area with a large island, bar stools, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fcfdd409-ac4f-4b9d-9f71-5f01a5042a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-b3c1-768c-87a2-e949a27478de.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with a fire pit and lounge chairs at sunset.",
        "public_id": "01a19e8c-b3c1-768c-87a2-e949a27478de",
        "storage_key": "property/6767906449167904/01a19e8c-b3c1-768c-87a2-e949a27478de.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor lounge area, complete with a cozy fire pit and comfortable seating, perfect for enjoying beautiful sunset views.",
      "link": "",
      "alt_text": "Outdoor patio seating area with a fire pit and lounge chairs at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea6be8d3-5a4e-4b69-ab69-46f1b0d3e80c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-9b0f-760e-8494-a4a73ac6815f.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies, surrounded by lush greenery and mountains.",
        "public_id": "01a19e8c-9b0f-760e-8494-a4a73ac6815f",
        "storage_key": "property/6767906449167904/01a19e8c-9b0f-760e-8494-a4a73ac6815f.webp",
        "width": 3072,
        "height": 2120
      },
      "title": "Community",
      "description": "Experience sophisticated living in this architecturally stunning apartment community, nestled amidst rolling hills and picturesque mountain vistas.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies, surrounded by lush greenery and mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1b36a01-8107-4d47-9414-1a2ecbc814e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8c-8f35-735a-9e23-d0f579813957.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex surrounded by lush green mountains.",
        "public_id": "01a19e8c-8f35-735a-9e23-d0f579813957",
        "storage_key": "property/6767906449167904/01a19e8c-8f35-735a-9e23-d0f579813957.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Expansive aerial view of a contemporary apartment building nestled against a backdrop of rolling, tree-covered mountains under a bright, cloudy sky.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex surrounded by lush green mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6264b521-f17f-4cc6-b993-d0ee0b56355c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-5f67-769c-bbed-50c78c451bf8.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows under a cloudy sky.",
        "public_id": "01a19e8b-5f67-769c-bbed-50c78c451bf8",
        "storage_key": "property/6767906449167904/01a19e8b-5f67-769c-bbed-50c78c451bf8.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "View of the modern apartment building's exterior showcasing balconies and large windows. A perfect place to call home.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and large windows under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28937abe-e530-46e9-9ff4-16a20127bde6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-33c6-74eb-8ef1-cbbac73574a0.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, weight machines, and punching bag.",
        "public_id": "01a19e8b-33c6-74eb-8ef1-cbbac73574a0",
        "storage_key": "property/6767906449167904/01a19e8b-33c6-74eb-8ef1-cbbac73574a0.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weight training equipment, and a boxing area.",
      "link": "",
      "alt_text": "Modern gym with treadmills, weight machines, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9950d3a3-0cc8-4cea-9b17-ae5a6fd21fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-2c0a-72b4-aa31-3e43c779dce0.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and tables in front of a modern apartment building.",
        "public_id": "01a19e8b-2c0a-72b4-aa31-3e43c779dce0",
        "storage_key": "property/6767906449167904/01a19e8b-2c0a-72b4-aa31-3e43c779dce0.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed outdoor space, featuring comfortable seating and string lights for evening ambiance. Perfect for enjoying the fresh air and scenic views.",
      "link": "",
      "alt_text": "Outdoor seating area with chairs and tables in front of a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1cca52c7-6828-41e2-b36a-289fe4084f00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-1f4d-7781-846b-6fa68fb59bda.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with seating and string lights next to apartment building",
        "public_id": "01a19e8b-1f4d-7781-846b-6fa68fb59bda",
        "storage_key": "property/6767906449167904/01a19e8b-1f4d-7781-846b-6fa68fb59bda.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor patio area, complete with comfortable seating, ambient string lights, and stunning views. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Outdoor patio area with seating and string lights next to apartment building",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c451ce17-614c-4cdb-b931-2598e3b1c151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-1960-742e-b830-827dafa84585.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging station in parking lot.",
        "public_id": "01a19e8b-1960-742e-b830-827dafa84585",
        "storage_key": "property/6767906449167904/01a19e8b-1960-742e-b830-827dafa84585.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Charge your electric vehicle at our convenient charging station, located in the community parking lot.",
      "link": "",
      "alt_text": "Electric vehicle charging station in parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d17f6a3-e75a-4ad6-9fb1-8d72ff04ab2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-174b-762a-81cb-66dc25c0b4a7.webp",
      "image_media": {
        "alt_text": "Gym equipment in a modern apartment complex fitness center.",
        "public_id": "01a19e8b-174b-762a-81cb-66dc25c0b4a7",
        "storage_key": "property/6767906449167904/01a19e8b-174b-762a-81cb-66dc25c0b4a7.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Workout in our state-of-the-art fitness center, fully equipped with cardio machines and weight-training equipment.",
      "link": "",
      "alt_text": "Gym equipment in a modern apartment complex fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fe2d3c2-e89e-482e-a12a-e9869f23d57c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-0ff6-7149-8725-51ce841f5a93.webp",
      "image_media": {
        "alt_text": "Coffee bar in apartment lobby with coffee maker and supplies",
        "public_id": "01a19e8b-0ff6-7149-8725-51ce841f5a93",
        "storage_key": "property/6767906449167904/01a19e8b-0ff6-7149-8725-51ce841f5a93.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a fresh cup of coffee at our convenient coffee bar, located in the community lobby. Perfect for a morning boost or an afternoon pick-me-up.",
      "link": "",
      "alt_text": "Coffee bar in apartment lobby with coffee maker and supplies",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1229376e-8b2e-4389-b317-bf361cbc4e5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8b-0028-74d3-a7b0-7ef221653982.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with balconies and mountain views.",
        "public_id": "01a19e8b-0028-74d3-a7b0-7ef221653982",
        "storage_key": "property/6767906449167904/01a19e8b-0028-74d3-a7b0-7ef221653982.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Aerial view of modern apartment buildings with balconies, surrounded by lush greenery and a mountainous backdrop.",
      "link": "",
      "alt_text": "Modern apartment buildings with balconies and mountain views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7380cf25-7d66-42ee-994d-f86577123fea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-e431-70ee-a7c2-442a20b13c6d.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern multifamily apartment building with surrounding parking lots and lush green landscape.",
        "public_id": "01a19e8a-e431-70ee-a7c2-442a20b13c6d",
        "storage_key": "property/6767906449167904/01a19e8a-e431-70ee-a7c2-442a20b13c6d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Expansive aerial view of a contemporary apartment complex nestled amidst rolling hills and dense forests, showcasing its modern architecture and ample parking.",
      "link": "",
      "alt_text": "Aerial view of a modern multifamily apartment building with surrounding parking lots and lush green landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0023b520-01f5-4146-b118-1304d3526a88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-e9b0-70aa-887f-98a3d695d7d1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a modern apartment building.",
        "public_id": "01a19e8a-e9b0-70aa-887f-98a3d695d7d1",
        "storage_key": "property/6767906449167904/01a19e8a-e9b0-70aa-887f-98a3d695d7d1.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and large umbrellas for shaded relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67506539-3f6c-49a0-a066-7f39e5960bdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-e257-77a9-8a44-58c5f5b96cb8.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with fire pit, grill, and seating in front of apartment buildings at sunset.",
        "public_id": "01a19e8a-e257-77a9-8a44-58c5f5b96cb8",
        "storage_key": "property/6767906449167904/01a19e8a-e257-77a9-8a44-58c5f5b96cb8.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy the beautiful sunset from the outdoor lounge area, complete with a fire pit, grill, and comfortable seating. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Outdoor lounge area with fire pit, grill, and seating in front of apartment buildings at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ded83bdc-b1c4-409a-bd17-d0ba619ff3dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-e0ab-754f-b361-d10cc270fd72.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex outdoor pool and lounge area with fire pit and seating.",
        "public_id": "01a19e8a-e0ab-754f-b361-d10cc270fd72",
        "storage_key": "property/6767906449167904/01a19e8a-e0ab-754f-b361-d10cc270fd72.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Experience resort-style living at our beautiful community, featuring a sparkling pool, comfortable lounge areas, and a modern fire pit perfect for evening relaxation.",
      "link": "",
      "alt_text": "Luxury apartment complex outdoor pool and lounge area with fire pit and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67c62d9b-50f7-4688-8437-0070c16af3f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-c61d-75ba-934b-2dcf20e837df.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, modern apartment buildings in background.",
        "public_id": "01a19e8a-c61d-75ba-934b-2dcf20e837df",
        "storage_key": "property/6767906449167904/01a19e8a-c61d-75ba-934b-2dcf20e837df.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our resort-style swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas. Surrounded by modern apartment buildings, this is the perfect place to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, modern apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41e25476-54f9-4559-abf9-7710281a0b5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-8d02-76ef-9327-d9d8fb8ddbf3.webp",
      "image_media": {
        "alt_text": "Living room with a tan couch, marble coffee table, and kitchen in the background.",
        "public_id": "01a19e8a-8d02-76ef-9327-d9d8fb8ddbf3",
        "storage_key": "property/6767906449167904/01a19e8a-8d02-76ef-9327-d9d8fb8ddbf3.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Enjoy the spacious living area, perfect for relaxing or entertaining, with an open-concept design leading to the modern kitchen.",
      "link": "",
      "alt_text": "Living room with a tan couch, marble coffee table, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e63e727-37b3-42a9-95be-925331082509",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-8441-746f-9507-a1dd2a11ca6b.webp",
      "image_media": {
        "alt_text": "Balcony with mountain view at sunset",
        "public_id": "01a19e8a-8441-746f-9507-a1dd2a11ca6b",
        "storage_key": "property/6767906449167904/01a19e8a-8441-746f-9507-a1dd2a11ca6b.webp",
        "width": 2500,
        "height": 1874
      },
      "title": "Community",
      "description": "Enjoy breathtaking mountain views from your private balcony as the sun sets over the horizon.",
      "link": "",
      "alt_text": "Balcony with mountain view at sunset",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bda033f6-5eb6-411e-a6bc-6a8cb1b485cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-64c4-77eb-8869-d8eb101d3d5a.webp",
      "image_media": {
        "alt_text": "Spacious modern lounge area with large sectional sofas, coffee tables with board games, and a large scenic mural on the wall.",
        "public_id": "01a19e8a-64c4-77eb-8869-d8eb101d3d5a",
        "storage_key": "property/6767906449167904/01a19e8a-64c4-77eb-8869-d8eb101d3d5a.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating, board games, and a captivating mural. Perfect for socializing or quiet relaxation.",
      "link": "",
      "alt_text": "Spacious modern lounge area with large sectional sofas, coffee tables with board games, and a large scenic mural on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a683caa-94e0-4597-bd08-4340508cddad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-5fbd-73f4-9e10-3fd31a436e29.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex at sunset with mountains in the background.",
        "public_id": "01a19e8a-5fbd-73f4-9e10-3fd31a436e29",
        "storage_key": "property/6767906449167904/01a19e8a-5fbd-73f4-9e10-3fd31a436e29.webp",
        "width": 2500,
        "height": 1872
      },
      "title": "Community",
      "description": "Experience luxury living in this stunning apartment community, nestled against a backdrop of rolling hills and majestic mountains. Enjoy the vibrant sunset from your new home.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex at sunset with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cae2b1dd-455d-4d15-b16b-f99f2a762462",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e8a-31d1-734f-86c2-c9d321808aec.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex nestled in a lush, wooded mountain landscape.",
        "public_id": "01a19e8a-31d1-734f-86c2-c9d321808aec",
        "storage_key": "property/6767906449167904/01a19e8a-31d1-734f-86c2-c9d321808aec.webp",
        "width": 2500,
        "height": 1734
      },
      "title": "Community",
      "description": "Experience luxury living with this stunning aerial view of our apartment community, surrounded by breathtaking natural beauty and scenic mountain vistas.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex nestled in a lush, wooded mountain landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f204892-9526-48a6-9041-5b05d79d209f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-75d1-7603-b5c5-c34051f0a03e.webp",
      "image_media": {
        "alt_text": "Modern seating area with plush chairs, booth seating, and a communal table in a well-lit common space.",
        "public_id": "01a19e88-75d1-7603-b5c5-c34051f0a03e",
        "storage_key": "property/6767906449167904/01a19e88-75d1-7603-b5c5-c34051f0a03e.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish common area, featuring comfortable seating arrangements, communal tables, and a welcoming ambiance for residents.",
      "link": "",
      "alt_text": "Modern seating area with plush chairs, booth seating, and a communal table in a well-lit common space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b23a68f4-4509-4c4c-96bd-556223c0a4bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-63fd-7429-82b1-c098892823d9.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, ellipticals, and stair climber, large windows with city views",
        "public_id": "01a19e88-63fd-7429-82b1-c098892823d9",
        "storage_key": "property/6767906449167904/01a19e88-63fd-7429-82b1-c098892823d9.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines and strength training equipment. Enjoy your workout with panoramic views of the city.",
      "link": "",
      "alt_text": "Modern apartment gym with treadmills, ellipticals, and stair climber, large windows with city views",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0283140c-3717-4b35-969f-b5cdaa06fb3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-4607-71cb-99b7-c9be1af99f0d.webp",
      "image_media": {
        "alt_text": "Cozy reading nook with a bookshelf-patterned wallpaper and a comfortable armchair.",
        "public_id": "01a19e88-4607-71cb-99b7-c9be1af99f0d",
        "storage_key": "property/6767906449167904/01a19e88-4607-71cb-99b7-c9be1af99f0d.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax in our charming reading nook, featuring unique bookshelf wallpaper and comfortable seating, perfect for unwinding.",
      "link": "",
      "alt_text": "Cozy reading nook with a bookshelf-patterned wallpaper and a comfortable armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d14d88c-52ac-4582-b7da-a0785f7dcc25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-3e45-7266-803b-e22ca0ccec5a.webp",
      "image_media": {
        "alt_text": "Grab and go market with refrigerators and a checkout kiosk.",
        "public_id": "01a19e88-3e45-7266-803b-e22ca0ccec5a",
        "storage_key": "property/6767906449167904/01a19e88-3e45-7266-803b-e22ca0ccec5a.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Conveniently stock up on snacks and essentials at our on-site grab-and-go market. Perfect for a quick bite or forgotten grocery items.",
      "link": "",
      "alt_text": "Grab and go market with refrigerators and a checkout kiosk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_992f51c3-0e02-421e-87e8-07112fef69d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-3733-7408-b547-4293d25fde48.webp",
      "image_media": {
        "alt_text": "Modern apartment complex exterior with mountain views.",
        "public_id": "01a19e88-3733-7408-b547-4293d25fde48",
        "storage_key": "property/6767906449167904/01a19e88-3733-7408-b547-4293d25fde48.webp",
        "width": 3072,
        "height": 1704
      },
      "title": "Community",
      "description": "Contemporary apartment buildings with ample parking and scenic mountain backdrop.",
      "link": "",
      "alt_text": "Modern apartment complex exterior with mountain views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a749745-58c6-4eb1-b7c0-85f41c2ecb7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-3414-7615-a1b8-6c398857165c.webp",
      "image_media": {
        "alt_text": "View from a retail area to a pool and building exterior.",
        "public_id": "01a19e88-3414-7615-a1b8-6c398857165c",
        "storage_key": "property/6767906449167904/01a19e88-3414-7615-a1b8-6c398857165c.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "View of the property's outdoor pool and surrounding amenities, visible from the building's retail or common area.",
      "link": "",
      "alt_text": "View from a retail area to a pool and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d6bb3ac-30a3-4008-8b46-7d34bad131af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-2892-77fd-b80a-4c3d4277952e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and a bar with stools.",
        "public_id": "01a19e88-2892-77fd-b80a-4c3d4277952e",
        "storage_key": "property/6767906449167904/01a19e88-2892-77fd-b80a-4c3d4277952e.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and socialize in the stylish resident lounge, featuring cozy seating nooks and a communal bar area perfect for casual gatherings or remote work.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and a bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7093d9e2-0245-43f8-bdad-5b0d0f4ab74d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-070b-762b-9955-a7e9795c7b04.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a resort-style pool and ample lounge seating.",
        "public_id": "01a19e88-070b-762b-9955-a7e9795c7b04",
        "storage_key": "property/6767906449167904/01a19e88-070b-762b-9955-a7e9795c7b04.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a luxurious lifestyle at our community, featuring a stunning outdoor pool and comfortable seating areas perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Modern apartment complex with a resort-style pool and ample lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e52f10b-a42c-48ee-a559-7b3a8f3a7218",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-0482-75bd-bb37-ed546151966a.webp",
      "image_media": {
        "alt_text": "Reception desk and lobby area with seating.",
        "public_id": "01a19e88-0482-75bd-bb37-ed546151966a",
        "storage_key": "property/6767906449167904/01a19e88-0482-75bd-bb37-ed546151966a.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Welcome to our modern and inviting leasing office and lobby, featuring comfortable seating and a stylish reception desk.",
      "link": "",
      "alt_text": "Reception desk and lobby area with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3004602e-37b4-4c57-8698-6ee97327c92a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e88-018e-72fd-bcdd-fb6629a98369.webp",
      "image_media": {
        "alt_text": "Community craft room with tables, chairs, and art supplies.",
        "public_id": "01a19e88-018e-72fd-bcdd-fb6629a98369",
        "storage_key": "property/6767906449167904/01a19e88-018e-72fd-bcdd-fb6629a98369.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Engage your creative side in the community craft room. Perfect for workshops, hobbies, or just a fun afternoon.",
      "link": "",
      "alt_text": "Community craft room with tables, chairs, and art supplies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_013eef50-dd50-40e8-a06d-a3ae07a4989a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-fa6d-72f9-b85b-85ac6559b316.webp",
      "image_media": {
        "alt_text": "Lobby with seating area and reception desk",
        "public_id": "01a19e87-fa6d-72f9-b85b-85ac6559b316",
        "storage_key": "property/6767906449167904/01a19e87-fa6d-72f9-b85b-85ac6559b316.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Stylish lobby and leasing office with comfortable seating and a modern reception desk, perfect for welcoming residents and guests.",
      "link": "",
      "alt_text": "Lobby with seating area and reception desk",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4590671-8e5f-4df5-ab81-d4370c53d5b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-e4cd-75af-8038-2c9b43d88947.webp",
      "image_media": {
        "alt_text": "Modern apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "01a19e87-e4cd-75af-8038-2c9b43d88947",
        "storage_key": "property/6767906449167904/01a19e87-e4cd-75af-8038-2c9b43d88947.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas. This amenity is perfect for enjoying sunny days and unwinding.",
      "link": "",
      "alt_text": "Modern apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de4059e3-065a-437b-b1a7-59ac5de9d178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-d758-758f-bf46-1e60f99202d0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a modern apartment complex.",
        "public_id": "01a19e87-d758-758f-bf46-1e60f99202d0",
        "storage_key": "property/6767906449167904/01a19e87-d758-758f-bf46-1e60f99202d0.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with plush lounge chairs and ample shade from umbrellas. An oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a modern apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00aa324d-b42d-4fab-a54d-edf4f5603f9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-d1e6-73c8-b86c-1b4bffd19e5d.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a swimming pool and lounge area.",
        "public_id": "01a19e87-d1e6-73c8-b86c-1b4bffd19e5d",
        "storage_key": "property/6767906449167904/01a19e87-d1e6-73c8-b86c-1b4bffd19e5d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Dive into relaxation at our resort-style swimming pool, surrounded by comfortable loungers and cabanas. Perfect for sunny days and unwinding.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with a swimming pool and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fec5b637-f9b6-414d-958c-f3ea7417aba2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-c92f-738a-ab81-bd3efdf4df4d.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a pool and seating areas at sunset.",
        "public_id": "01a19e87-c92f-738a-ab81-bd3efdf4df4d",
        "storage_key": "property/6767906449167904/01a19e87-c92f-738a-ab81-bd3efdf4df4d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Experience luxury living with our resort-style pool, outdoor lounge areas, and modern apartment buildings. Enjoy the beautiful sunset views.",
      "link": "",
      "alt_text": "Modern apartment complex with a pool and seating areas at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6d0588a-9c2f-4644-83ad-e7771df80b23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-c4a5-7132-9492-37eca7de6b21.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex nestled in a lush, green mountain landscape.",
        "public_id": "01a19e87-c4a5-7132-9492-37eca7de6b21",
        "storage_key": "property/6767906449167904/01a19e87-c4a5-7132-9492-37eca7de6b21.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Discover luxury apartment living with stunning mountain views. Our community offers a serene escape with modern amenities and beautiful surroundings.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex nestled in a lush, green mountain landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17b04370-9a71-49f9-9037-c6c5f17e6342",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-abab-72c5-b042-39370c4e06e2.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a pool, parking lot, and lounge areas.",
        "public_id": "01a19e87-abab-72c5-b042-39370c4e06e2",
        "storage_key": "property/6767906449167904/01a19e87-abab-72c5-b042-39370c4e06e2.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Experience resort-style living at our modern apartment community, featuring a sparkling pool, ample parking, and stylish outdoor lounge areas.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with a pool, parking lot, and lounge areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1baee2c3-7b84-4d63-9163-d6c77b83255d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-848f-707c-8879-95c64a442182.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with a large sectional sofa, fire pit, and chairs.",
        "public_id": "01a19e87-848f-707c-8879-95c64a442182",
        "storage_key": "property/6767906449167904/01a19e87-848f-707c-8879-95c64a442182.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor lounge area, complete with a cozy fire pit and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor lounge area with a large sectional sofa, fire pit, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4fb9fde6-93e3-4c88-910d-e9d07ffd0fa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-7a86-750f-b73f-aa112e163c85.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking lush green trees and distant blue mountains under a cloudy sky.",
        "public_id": "01a19e87-7a86-750f-b73f-aa112e163c85",
        "storage_key": "property/6767906449167904/01a19e87-7a86-750f-b73f-aa112e163c85.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy breathtaking views of rolling green hills and distant mountains from your private balcony. Experience the tranquility of nature combined with modern apartment living.",
      "link": "",
      "alt_text": "View from balcony overlooking lush green trees and distant blue mountains under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3415ea10-3c99-484b-b963-e125ea29c6ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-7c12-72e0-a198-5a4c989045fa.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirrors, and a walk-in closet.",
        "public_id": "01a19e87-7c12-72e0-a198-5a4c989045fa",
        "storage_key": "property/6767906449167904/01a19e87-7c12-72e0-a198-5a4c989045fa.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Expansive modern bathroom featuring a double vanity with sleek fixtures, ample counter space, and large mirrors. Includes a separate walk-in closet for storage.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, large mirrors, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc3c94eb-6c33-416f-a859-ebbebbacf167",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-71bb-7088-bf2b-338a00623402.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex surrounded by lush greenery and mountains.",
        "public_id": "01a19e87-71bb-7088-bf2b-338a00623402",
        "storage_key": "property/6767906449167904/01a19e87-71bb-7088-bf2b-338a00623402.webp",
        "width": 3072,
        "height": 2167
      },
      "title": "Community",
      "description": "Experience modern living in this stunning apartment complex, nestled amidst rolling hills and picturesque mountains. Enjoy a vibrant community atmosphere with beautiful landscaping.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex surrounded by lush greenery and mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e62f7a7-b670-438e-a17c-33cb97313a96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-560a-76e5-8fa8-7dc8f97d158a.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with colorful autumn foliage and a sunset.",
        "public_id": "01a19e87-560a-76e5-8fa8-7dc8f97d158a",
        "storage_key": "property/6767906449167904/01a19e87-560a-76e5-8fa8-7dc8f97d158a.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Modern apartment buildings nestled among vibrant autumn trees, with a scenic mountain backdrop and a dramatic sunset sky.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with colorful autumn foliage and a sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_be547688-1d1b-45d1-9213-cca3cc18c6fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-555e-7429-a5cb-a10a543bc236.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with a pool and mountain backdrop at sunset.",
        "public_id": "01a19e87-555e-7429-a5cb-a10a543bc236",
        "storage_key": "property/6767906449167904/01a19e87-555e-7429-a5cb-a10a543bc236.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Experience luxury living at this modern apartment complex, featuring a sparkling pool, abundant amenities, and stunning mountain views. Enjoy resort-style living year-round.",
      "link": "",
      "alt_text": "Modern apartment building exterior with a pool and mountain backdrop at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a43cb2ab-4109-43d4-903e-c41b44af4fd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-4025-779b-bda9-a521ebd61cd4.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with mountain views at sunset.",
        "public_id": "01a19e87-4025-779b-bda9-a521ebd61cd4",
        "storage_key": "property/6767906449167904/01a19e87-4025-779b-bda9-a521ebd61cd4.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Discover luxury living at this stunning apartment community, featuring modern architecture and breathtaking mountain vistas.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with mountain views at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6cbf0072-f595-4e0f-83b6-61ce408f1c57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-3c66-754f-8d32-53cb6d957b8b.webp",
      "image_media": {
        "alt_text": "View of mountains from a modern apartment building balcony with outdoor seating.",
        "public_id": "01a19e87-3c66-754f-8d32-53cb6d957b8b",
        "storage_key": "property/6767906449167904/01a19e87-3c66-754f-8d32-53cb6d957b8b.webp",
        "width": 2500,
        "height": 1874
      },
      "title": "Community",
      "description": "Enjoy breathtaking mountain views from your private balcony, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "View of mountains from a modern apartment building balcony with outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05877686-6431-4cf2-8d24-f3203f27cc79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-2ed2-7108-95f7-89c22b3889a6.webp",
      "image_media": {
        "alt_text": "Modern apartment building with balconies overlooking a forest and mountains at sunset.",
        "public_id": "01a19e87-2ed2-7108-95f7-89c22b3889a6",
        "storage_key": "property/6767906449167904/01a19e87-2ed2-7108-95f7-89c22b3889a6.webp",
        "width": 2500,
        "height": 1874
      },
      "title": "Community",
      "description": "Enjoy breathtaking sunset views from your balcony, overlooking a lush forest and majestic mountains. This community offers a serene and picturesque living experience.",
      "link": "",
      "alt_text": "Modern apartment building with balconies overlooking a forest and mountains at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ed14811-fdd2-4b48-a2ec-b1c8ad79ab6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e87-2a49-7678-b87a-4eaf5f4186e9.webp",
      "image_media": {
        "alt_text": "Courtyard seating area with fire pit, string lights, and lounge chairs.",
        "public_id": "01a19e87-2a49-7678-b87a-4eaf5f4186e9",
        "storage_key": "property/6767906449167904/01a19e87-2a49-7678-b87a-4eaf5f4186e9.webp",
        "width": 2500,
        "height": 1670
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our beautifully designed courtyard, complete with comfortable seating, a cozy fire pit, and ambient string lights for evening relaxation.",
      "link": "",
      "alt_text": "Courtyard seating area with fire pit, string lights, and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b4299c4-4bda-4be8-b7b4-50b4e2491040",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e86-fd7f-77ff-b22d-61632fceb826.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a large outdoor swimming pool and lounge area surrounded by autumn foliage.",
        "public_id": "01a19e86-fd7f-77ff-b22d-61632fceb826",
        "storage_key": "property/6767906449167904/01a19e86-fd7f-77ff-b22d-61632fceb826.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor swimming pool and spacious lounge area. Enjoy the beautiful mountain views and vibrant autumn colors surrounding the property.",
      "link": "",
      "alt_text": "Modern apartment complex with a large outdoor swimming pool and lounge area surrounded by autumn foliage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2b0fd59-9335-4850-8efb-1f7d89933edc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e86-e2f9-7727-8614-7bac37983ec3.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex surrounded by autumn foliage.",
        "public_id": "01a19e86-e2f9-7727-8614-7bac37983ec3",
        "storage_key": "property/6767906449167904/01a19e86-e2f9-7727-8614-7bac37983ec3.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Experience luxury living in this stunning apartment community, nestled amidst the vibrant colors of fall. Enjoy the modern architecture and beautiful natural surroundings.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex surrounded by autumn foliage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c25a7621-b65c-418e-a80f-d6bf8716de0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e86-b284-74d8-81f3-1b02e2946877.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood nestled among rolling hills during autumn with vibrant fall foliage.",
        "public_id": "01a19e86-b284-74d8-81f3-1b02e2946877",
        "storage_key": "property/6767906449167904/01a19e86-b284-74d8-81f3-1b02e2946877.webp",
        "width": 2500,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover a charming community surrounded by the breathtaking beauty of autumn. Rolling hills and colorful foliage create a picturesque backdrop for this suburban neighborhood.",
      "link": "",
      "alt_text": "Aerial view of a suburban neighborhood nestled among rolling hills during autumn with vibrant fall foliage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_511a3a99-5f4e-40fd-a09b-9b326d18b437",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e86-71c0-723e-b3ff-7a3f2aedcf39.webp",
      "image_media": {
        "alt_text": "3-bedroom, 2-bathroom floor plan",
        "public_id": "01a19e86-71c0-723e-b3ff-7a3f2aedcf39",
        "storage_key": "property/6767906449167904/01a19e86-71c0-723e-b3ff-7a3f2aedcf39.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Floorplan",
      "description": "A top-down view of a 3-bedroom, 2-bathroom floor plan, showcasing the layout of living spaces, bedrooms, bathrooms, and a balcony.",
      "link": "",
      "alt_text": "3-bedroom, 2-bathroom floor plan",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_006dff7f-f69d-4796-b027-b18e6572c79f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-fac6-77de-99c8-3b9ea945d213.webp",
      "image_media": {
        "alt_text": "A modern workspace with a bookshelf-themed wallpaper and a painting.",
        "public_id": "01a19e82-fac6-77de-99c8-3b9ea945d213",
        "storage_key": "property/6767906449167904/01a19e82-fac6-77de-99c8-3b9ea945d213.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Discover a productive workspace with unique bookshelf wallpaper and modern art. Ideal for remote work or study.",
      "link": "",
      "alt_text": "A modern workspace with a bookshelf-themed wallpaper and a painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08cecefe-089f-48cc-8726-d2f4ef2c5880",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-e022-716f-9f0b-4fc9d522d225.webp",
      "image_media": {
        "alt_text": "Community art studio with large wooden tables, chairs, easels, and windows overlooking an outdoor area.",
        "public_id": "01a19e82-e022-716f-9f0b-4fc9d522d225",
        "storage_key": "property/6767906449167904/01a19e82-e022-716f-9f0b-4fc9d522d225.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Unleash your creativity in our community art studio, complete with spacious tables, easels, and inspiring views.",
      "link": "",
      "alt_text": "Community art studio with large wooden tables, chairs, easels, and windows overlooking an outdoor area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f80f712-8057-4b4a-a206-e6ae2e31d971",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-c139-762d-bf0c-ff836414430e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and decorative elements.",
        "public_id": "01a19e82-c139-762d-bf0c-ff836414430e",
        "storage_key": "property/6767906449167904/01a19e82-c139-762d-bf0c-ff836414430e.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating, ambient lighting, and a sophisticated atmosphere perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6013b098-69e2-474a-b5ee-a1623908321e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-c243-731c-a147-3f2f2f7a6ad0.webp",
      "image_media": {
        "alt_text": "Art studio with large tables, easels, and chairs",
        "public_id": "01a19e82-c243-731c-a147-3f2f2f7a6ad0",
        "storage_key": "property/6767906449167904/01a19e82-c243-731c-a147-3f2f2f7a6ad0.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Unleash your creativity in our dedicated art studio, featuring ample table space and easels for all your artistic endeavors. Perfect for classes or personal projects.",
      "link": "",
      "alt_text": "Art studio with large tables, easels, and chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21b01b56-417d-4676-9904-fe73c14ccf39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-aadf-77ce-8814-71f55936585e.webp",
      "image_media": {
        "alt_text": "Lobby with seating areas, pool table, and bar with stools.",
        "public_id": "01a19e82-aadf-77ce-8814-71f55936585e",
        "storage_key": "property/6767906449167904/01a19e82-aadf-77ce-8814-71f55936585e.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and socialize in our spacious lobby, featuring comfortable seating, a pool table, and a modern bar area perfect for casual gatherings.",
      "link": "",
      "alt_text": "Lobby with seating areas, pool table, and bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55bf9fcc-96dd-47d6-a6cc-818c675df04d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-a6b3-7259-b40d-ef0f0e4a9173.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with surrounding landscape and mountains.",
        "public_id": "01a19e82-a6b3-7259-b40d-ef0f0e4a9173",
        "storage_key": "property/6767906449167904/01a19e82-a6b3-7259-b40d-ef0f0e4a9173.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "A panoramic view of a sleek, modern apartment complex nestled amidst lush greenery, with rolling mountains in the background under a bright, cloudy sky.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with surrounding landscape and mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f52626e1-256e-47fd-8505-f9fe6752c966",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-a4a8-7299-86ca-860ca2c35648.webp",
      "image_media": {
        "alt_text": "Mailboxes in apartment building hallway with wood floors and modern lighting.",
        "public_id": "01a19e82-a4a8-7299-86ca-860ca2c35648",
        "storage_key": "property/6767906449167904/01a19e82-a4a8-7299-86ca-860ca2c35648.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Secure mailroom featuring individual mailboxes and a sleek, modern design with herringbone wood flooring and contemporary lighting.",
      "link": "",
      "alt_text": "Mailboxes in apartment building hallway with wood floors and modern lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c721e46e-2972-483c-a368-cb1782d7cc0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-90a2-76d7-adf1-645af25e11b4.webp",
      "image_media": {
        "alt_text": "Shuffleboard table and pool table in a modern community lounge area.",
        "public_id": "01a19e82-90a2-76d7-adf1-645af25e11b4",
        "storage_key": "property/6767906449167904/01a19e82-90a2-76d7-adf1-645af25e11b4.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a game of shuffleboard or pool in our vibrant community lounge, perfect for resident gatherings and entertainment.",
      "link": "",
      "alt_text": "Shuffleboard table and pool table in a modern community lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa6d75aa-d407-4651-9503-76f72d503ec6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-915d-72cb-b01e-d6537855ccd3.webp",
      "image_media": {
        "alt_text": "Modern seating area with marble-topped tables and plush chairs, adjacent to a communal workspace with bar seating and pendant lights.",
        "public_id": "01a19e82-915d-72cb-b01e-d6537855ccd3",
        "storage_key": "property/6767906449167904/01a19e82-915d-72cb-b01e-d6537855ccd3.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal spaces, featuring comfortable seating and a vibrant atmosphere perfect for working or unwinding.",
      "link": "",
      "alt_text": "Modern seating area with marble-topped tables and plush chairs, adjacent to a communal workspace with bar seating and pendant lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99d6f04b-6a88-4b84-a632-46be85bd0387",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-82fd-757b-b04f-0be84813a640.webp",
      "image_media": {
        "alt_text": "Mailroom with mailboxes and a luggage cart",
        "public_id": "01a19e82-82fd-757b-b04f-0be84813a640",
        "storage_key": "property/6767906449167904/01a19e82-82fd-757b-b04f-0be84813a640.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Convenient mailroom featuring individual mailboxes and a luggage cart for residents' use.",
      "link": "",
      "alt_text": "Mailroom with mailboxes and a luggage cart",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad31fb85-69fa-4459-ade1-39ee413e7696",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-5c9a-7669-92ed-1d9f6614648b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island sink.",
        "public_id": "01a19e82-5c9a-7669-92ed-1d9f6614648b",
        "storage_key": "property/6767906449167904/01a19e82-5c9a-7669-92ed-1d9f6614648b.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring gray cabinetry, stainless steel appliances including a refrigerator and microwave, and a spacious island with a black faucet.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f09cf18f-dd28-4bfc-97f9-5c6c3075e22d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-559f-7010-8e87-313b8d478d7d.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with sink and dishwasher, open to living room with couch and balcony.",
        "public_id": "01a19e82-559f-7010-8e87-313b8d478d7d",
        "storage_key": "property/6767906449167904/01a19e82-559f-7010-8e87-313b8d478d7d.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Stylish kitchen island with seating and modern appliances, flowing into a bright living area with natural light and balcony access.",
      "link": "",
      "alt_text": "Modern kitchen island with sink and dishwasher, open to living room with couch and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2a0e059-fbfb-4bf3-a6e9-f051cb56dcfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-54a3-72eb-93c3-a8edc1668435.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower, and view into bedroom",
        "public_id": "01a19e82-54a3-72eb-93c3-a8edc1668435",
        "storage_key": "property/6767906449167904/01a19e82-54a3-72eb-93c3-a8edc1668435.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with modern fixtures, a walk-in glass shower, and a view into the adjacent bedroom.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, walk-in shower, and view into bedroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea8821a9-aec1-4564-8e10-fb2dc52b45a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-54e1-776d-ab9a-95d7c10643e3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with bar stools.",
        "public_id": "01a19e82-54e1-776d-ab9a-95d7c10643e3",
        "storage_key": "property/6767906449167904/01a19e82-54e1-776d-ab9a-95d7c10643e3.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring sleek gray cabinetry, a full suite of stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20decdf7-86de-4b3d-9dd4-f4261dd932e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-424a-72be-a527-a8546decd45c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower and a bedroom visible through an open door.",
        "public_id": "01a19e82-424a-72be-a527-a8546decd45c",
        "storage_key": "property/6767906449167904/01a19e82-424a-72be-a527-a8546decd45c.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed apartment featuring a sleek walk-in shower and a comfortable bedroom. The perfect blend of style and relaxation awaits.",
      "link": "",
      "alt_text": "Modern bathroom with a walk-in shower and a bedroom visible through an open door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19c5830e-9780-480c-a6ad-1ed476dca847",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-3958-763f-9a00-5bad4c0896a4.webp",
      "image_media": {
        "alt_text": "Pet grooming station with stainless steel tub, sink, grooming table, and dryer.",
        "public_id": "01a19e82-3958-763f-9a00-5bad4c0896a4",
        "storage_key": "property/6767906449167904/01a19e82-3958-763f-9a00-5bad4c0896a4.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Grooming station for pets, featuring a stainless steel tub, sink, and professional grooming table with a dryer for your furry friends.",
      "link": "",
      "alt_text": "Pet grooming station with stainless steel tub, sink, grooming table, and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59134e03-996a-4831-8871-a608f2b41e2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-228f-73cc-92e5-23a4626c4607.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, lamps, and a ceiling fan.",
        "public_id": "01a19e82-228f-73cc-92e5-23a4626c4607",
        "storage_key": "property/6767906449167904/01a19e82-228f-73cc-92e5-23a4626c4607.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstands with decorative lamps, and a modern ceiling fan for climate control. Large windows offer natural light and scenic views.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, lamps, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_072b1272-4d09-4102-9946-b98cba2f7265",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-10f3-77eb-8116-6c5d315d5350.webp",
      "image_media": {
        "alt_text": "Exterior view of The Ellison apartment building with balconies and parking lot.",
        "public_id": "01a19e82-10f3-77eb-8116-6c5d315d5350",
        "storage_key": "property/6767906449167904/01a19e82-10f3-77eb-8116-6c5d315d5350.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Modern exterior of The Ellison apartment building, showcasing its architecture and amenities, including balconies and a well-maintained landscape.",
      "link": "",
      "alt_text": "Exterior view of The Ellison apartment building with balconies and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93a6fd9d-1f0a-4157-85ea-1f4e05da509d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-0946-70ed-80df-a67e370b9d3c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and a wicker basket.",
        "public_id": "01a19e82-0946-70ed-80df-a67e370b9d3c",
        "storage_key": "property/6767906449167904/01a19e82-0946-70ed-80df-a67e370b9d3c.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving for storage and a decorative wicker basket. Perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and a wicker basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_676283ce-78de-4d78-8a24-3c643f63a13d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e82-008c-7417-8d40-ee2fabc1f3c6.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern multifamily apartment complex nestled against a lush, tree-covered mountain under a vibrant sunset sky.",
        "public_id": "01a19e82-008c-7417-8d40-ee2fabc1f3c6",
        "storage_key": "property/6767906449167904/01a19e82-008c-7417-8d40-ee2fabc1f3c6.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Experience resort-style living at this stunning multifamily property, featuring modern architecture set against breathtaking mountain scenery and a vibrant sunset.",
      "link": "",
      "alt_text": "Aerial view of a modern multifamily apartment complex nestled against a lush, tree-covered mountain under a vibrant sunset sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a33760b-2c44-41be-9345-2130ba439396",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-e6ea-762d-94a6-05491683af05.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and closet.",
        "public_id": "01a19e81-e6ea-762d-94a6-05491683af05",
        "storage_key": "property/6767906449167904/01a19e81-e6ea-762d-94a6-05491683af05.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a stylish dresser, a large mirror, and ample closet space for all your needs.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6e45e9ae-5bb9-4294-b5d1-44f91ce7e284",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-d2d1-73e8-8eac-c10e7881c300.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and chairs near a pool with lounge chairs.",
        "public_id": "01a19e81-d2d1-73e8-8eac-c10e7881c300",
        "storage_key": "property/6767906449167904/01a19e81-d2d1-73e8-8eac-c10e7881c300.webp",
        "width": 2500,
        "height": 1670
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating around a fire pit, adjacent to the sparkling pool.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit and chairs near a pool with lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc77ff3c-4d48-41e3-af23-c92321143b84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-c0ff-742a-b4bb-27dac59ce9eb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, fire pit, and modern seating at sunset.",
        "public_id": "01a19e81-c0ff-742a-b4bb-27dac59ce9eb",
        "storage_key": "property/6767906449167904/01a19e81-c0ff-742a-b4bb-27dac59ce9eb.webp",
        "width": 2500,
        "height": 1670
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge seating and a cozy fire pit. Perfect for enjoying a beautiful sunset.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, fire pit, and modern seating at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21055d95-c174-4e39-beac-954ad7dae71a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-b72b-71a8-bf04-dc883aa5a2b0.webp",
      "image_media": {
        "alt_text": "Balcony view of apartment buildings at sunset",
        "public_id": "01a19e81-b72b-71a8-bf04-dc883aa5a2b0",
        "storage_key": "property/6767906449167904/01a19e81-b72b-71a8-bf04-dc883aa5a2b0.webp",
        "width": 2500,
        "height": 1670
      },
      "title": "Apartment",
      "description": "Enjoy breathtaking sunset views from your private balcony, overlooking the community and scenic landscape. A perfect spot to unwind and relax.",
      "link": "",
      "alt_text": "Balcony view of apartment buildings at sunset",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eef9c1b4-0120-44f2-80d5-2b45f70dcece",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-a6a8-737b-8dd2-98d83158df6b.webp",
      "image_media": {
        "alt_text": "View of apartments surrounded by autumn foliage and mountains",
        "public_id": "01a19e81-a6a8-737b-8dd2-98d83158df6b",
        "storage_key": "property/6767906449167904/01a19e81-a6a8-737b-8dd2-98d83158df6b.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Experience the beauty of autumn from our apartments, nestled amidst colorful fall foliage with stunning mountain views.",
      "link": "",
      "alt_text": "View of apartments surrounded by autumn foliage and mountains",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ef880e4-baff-4bfb-88df-8bd4dd9280c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-a201-7259-8203-ad354ecc0bb4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings nestled among trees in autumn foliage.",
        "public_id": "01a19e81-a201-7259-8203-ad354ecc0bb4",
        "storage_key": "property/6767906449167904/01a19e81-a201-7259-8203-ad354ecc0bb4.webp",
        "width": 2500,
        "height": 1826
      },
      "title": "Community",
      "description": "Discover our apartment community surrounded by the vibrant colors of fall, offering a picturesque living experience in a scenic natural setting.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings nestled among trees in autumn foliage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccd528b1-4934-4bd6-ae03-2c2499e0e995",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-9eb8-754f-a6e7-bc527bce6610.webp",
      "image_media": {
        "alt_text": "Balcony view of autumn forest and mountains at sunset.",
        "public_id": "01a19e81-9eb8-754f-a6e7-bc527bce6610",
        "storage_key": "property/6767906449167904/01a19e81-9eb8-754f-a6e7-bc527bce6610.webp",
        "width": 2500,
        "height": 1670
      },
      "title": "Community",
      "description": "Enjoy breathtaking views of the autumn foliage and rolling mountains from your private balcony.",
      "link": "",
      "alt_text": "Balcony view of autumn forest and mountains at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13c9e22c-9a0b-4d9a-bc32-abd51c56642b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-984e-76fb-9a8f-9871480dcf49.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex surrounded by colorful autumn trees and mountains.",
        "public_id": "01a19e81-984e-76fb-9a8f-9871480dcf49",
        "storage_key": "property/6767906449167904/01a19e81-984e-76fb-9a8f-9871480dcf49.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Experience luxury living in this stunning apartment community, nestled amidst breathtaking mountain scenery and vibrant fall foliage. Enjoy the perfect blend of nature and modern comfort.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex surrounded by colorful autumn trees and mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_383f6621-096b-4703-b123-e54f1bef08a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-72c5-731a-b10f-7200e335682a.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex surrounded by fall foliage and mountains.",
        "public_id": "01a19e81-72c5-731a-b10f-7200e335682a",
        "storage_key": "property/6767906449167904/01a19e81-72c5-731a-b10f-7200e335682a.webp",
        "width": 2500,
        "height": 1875
      },
      "title": "Community",
      "description": "Discover modern living at our apartment community, nestled amidst picturesque fall colors and majestic mountains. Enjoy a vibrant lifestyle in a serene setting.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex surrounded by fall foliage and mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de647b48-ff9a-47ef-acc7-2016cfc3aac5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a19e81-5cbd-7635-b2b8-206627e01fc6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, fire pit, and seating.",
        "public_id": "01a19e81-5cbd-7635-b2b8-206627e01fc6",
        "storage_key": "property/6767906449167904/01a19e81-5cbd-7635-b2b8-206627e01fc6.webp",
        "width": 2500,
        "height": 1670
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable lounge chairs, a cozy fire pit, and ample seating for gatherings.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, fire pit, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_73cb0017-1c7a-475d-99b5-3f732c60920c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Thai Chili Asian Bistro Asheville, NC",
      "poi_type": "Restaurants",
      "poi_address": "1550 Hendersonville Rd Suit 100, Asheville, NC 28803, USA",
      "poi_short_description": "Relaxed Thai eatery featuring an outdoor patio and a menu of flavorful curries and soups.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-06f3-768d-9454-b05b82b87b19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-06f3-768d-9454-b05b82b87b19",
        "storage_key": "property/6767906449167904/01a18e21-06f3-768d-9454-b05b82b87b19.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://thaichiliasianbistronc.kwickmenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10061457674437947790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-chili-asian-bistro-asheville-nc",
      "poi_latitude": "35.515546",
      "poi_longitude": "-82.5269378",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 828-505-4224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRyHopvzWYgRjnGAb3J6oYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_492d899f-8278-4967-afd8-04d5761e74ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Abeja's House Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1550 Hendersonville Rd #116, Asheville, NC 28803, USA",
      "poi_short_description": "Cozy midday canteen featuring American and Latin breakfast & lunch options, plus desserts.",
      "poi_long_description": "Cozy midday canteen featuring American and Latin breakfast & lunch options, plus desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-0654-7438-8a23-e23b526084bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-0654-7438-8a23-e23b526084bb",
        "storage_key": "property/6767906449167904/01a18e21-0654-7438-8a23-e23b526084bb.webp",
        "width": 765,
        "height": 1020
      },
      "poi_business_url": "http://abejashousecafe.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17310128295042042506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abejas-house-cafe",
      "poi_latitude": "35.515149799999996",
      "poi_longitude": "-82.5268457",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 828-505-3696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-UNWjoTyWYgRikprqvjtOfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "custom_b5452661-0bce-4b96-90fb-8e85a2c5f2a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Sushi & Hibachi",
      "poi_type": "Restaurants",
      "poi_address": "1636 Hendersonville Rd #175, Asheville, NC 28803, USA",
      "poi_short_description": "Simple cafe with a full Japanese menu along with other Asian fare including Thai & Chinese.",
      "poi_long_description": "Simple cafe with a full Japanese menu along with other Asian fare including Thai & Chinese.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-0af4-7497-aa68-59023b643e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-0af4-7497-aa68-59023b643e86",
        "storage_key": "property/6767906449167904/01a18e21-0af4-7497-aa68-59023b643e86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ashevillesushius.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9163474694024833357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-sushi--hibachi",
      "poi_latitude": "35.5124767",
      "poi_longitude": "-82.5257939",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 828-277-3838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cQuw4PyWYgRTamhHa8zK38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_b62c7d2e-b9a7-46a9-92c9-afcdc0cead04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "230 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-0cc5-71dc-84c1-7624621799ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-0cc5-71dc-84c1-7624621799ed",
        "storage_key": "property/6767906449167904/01a18e21-0cc5-71dc-84c1-7624621799ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/north-carolina/asheville?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=5035454920225458843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.5611189",
      "poi_longitude": "-82.5397753",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 828-274-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7dDmxjzWYgRmwqIKpKH4UU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_6c410511-00fc-49a9-855c-71bbad56a109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Juanchos Fonda",
      "poi_type": "Restaurants",
      "poi_address": "2619 Sweeten Creek Rd #10, Asheville, NC 28803, USA",
      "poi_short_description": "Wholesome, fully gluten-free Colombian restaurant serving scratch-made empanadas and authentic entrees.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-09c4-756e-af42-c0f76253926e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-09c4-756e-af42-c0f76253926e",
        "storage_key": "property/6767906449167904/01a18e21-09c4-756e-af42-c0f76253926e.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "https://juanchosfonda.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15001251342282420263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juanchos-fonda",
      "poi_latitude": "35.5097446",
      "poi_longitude": "-82.5183709",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 828-505-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42ur11nzWYgRJ3AYo50mL9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "custom_1716cd07-fe10-41e4-8d9f-dfba8040cabc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Pelican's Snoballs of Asheville",
      "poi_type": "Restaurants",
      "poi_address": "2601 Sweeten Creek Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Chain doling out New Orleans-style shaved ice in a wide variety of classic & unique flavors.",
      "poi_long_description": "Chain doling out New Orleans-style shaved ice in a wide variety of classic & unique flavors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-08df-7048-93d5-21ceae70e8a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-08df-7048-93d5-21ceae70e8a4",
        "storage_key": "property/6767906449167904/01a18e21-08df-7048-93d5-21ceae70e8a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pelicanssnoballs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329107513322929889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pelicans-snoballs-of-asheville",
      "poi_latitude": "35.5108907",
      "poi_longitude": "-82.51895259999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 828-925-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-06ccad82dc49",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi5qReYDyWYgR4X4WxlgUFDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_de1eab04-b112-4f8d-86d7-b2de67bbee93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Luella's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "33 Town Square Blvd Ste 110, Asheville, NC 28803, USA",
      "poi_short_description": "Smoked meats with housemade sauces offered with local beer & cocktails in a homey setting.",
      "poi_long_description": "Smoked meats with housemade sauces offered with local beer & cocktails in a homey setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-0710-75dc-b1be-7229bd0d4b83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-0710-75dc-b1be-7229bd0d4b83",
        "storage_key": "property/6767906449167904/01a17960-0710-75dc-b1be-7229bd0d4b83.webp",
        "width": 796,
        "height": 1280
      },
      "poi_business_url": "https://www.luellasbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9837808070509947736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luellas-bar-b-que",
      "poi_latitude": "35.4846107",
      "poi_longitude": "-82.5564982",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-676-3855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRaM8QTtWYgRWGs3M1Hqhog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_7ebc1a70-c585-4268-a402-2f9db55582c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Posana Biltmore Park",
      "poi_type": "Restaurants",
      "poi_address": "264 Thetford St #110, Asheville, NC 28803, USA",
      "poi_short_description": "Sophisticated farm-to-table restaurant serving housemade pastas and steaks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-0fa1-7339-b1b1-e0164ad538d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-0fa1-7339-b1b1-e0164ad538d9",
        "storage_key": "property/6767906449167904/01a17960-0fa1-7339-b1b1-e0164ad538d9.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://posanarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8065898021985519299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "posana-biltmore-park",
      "poi_latitude": "35.4845987",
      "poi_longitude": "-82.5576813",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-276-2021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJee0vOCftWYgRwwb5GoTT728",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8f8dd436-b221-4838-a73a-26f67c0cb799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Corner Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "3 Boston Way, Asheville, NC 28803, USA",
      "poi_short_description": "Set in a Victorian cottage with a patio, this upscale venue serves New American fare & craft drinks.",
      "poi_long_description": "Set in a Victorian cottage with a patio, this upscale venue serves New American fare & craft drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-06a4-75fa-8745-7a8f95c42bda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-06a4-75fa-8745-7a8f95c42bda",
        "storage_key": "property/6767906449167904/01a18e21-06a4-75fa-8745-7a8f95c42bda.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://thecornerkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10809315808057707609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corner-kitchen",
      "poi_latitude": "35.5662844",
      "poi_longitude": "-82.5411817",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 828-274-2439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38Csbj3zWYgRWUxLDHVnApY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8ffae052-530c-483d-aaec-0f6d07a03472",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Cúrate Bar de Tapas",
      "poi_type": "Restaurants",
      "poi_address": "13 Biltmore Ave, Asheville, NC 28801, USA",
      "poi_short_description": "Lively Spanish restaurant serving diverse small plates and signature lamb skewers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-067b-76ff-9740-98b7f4cc6d1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-067b-76ff-9740-98b7f4cc6d1a",
        "storage_key": "property/6767906449167904/01a18e21-067b-76ff-9740-98b7f4cc6d1a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.curatetapasbar.com/bar-de-tapas",
      "poi_directions_map_url": "https://maps.google.com/?cid=5972852968681244084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crate-bar-de-tapas",
      "poi_latitude": "35.5942295",
      "poi_longitude": "-82.55167999999999",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 828-239-2946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNX8iKGnzWYgRtAXiJSHW41I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "custom_8895df83-5e45-4c92-8e2f-a03b39bbb5f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Chestnut",
      "poi_type": "Restaurants",
      "poi_address": "48 Biltmore Ave, Asheville, NC 28801, USA",
      "poi_short_description": "New American eatery for seasonal bites & homemade treats in restored 1920s digs with a full bar.",
      "poi_long_description": "New American eatery for seasonal bites & homemade treats in restored 1920s digs with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-0937-7259-aa7f-ce0758d1d75d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-0937-7259-aa7f-ce0758d1d75d",
        "storage_key": "property/6767906449167904/01a18e21-0937-7259-aa7f-ce0758d1d75d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chestnutasheville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7244855173582302875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chestnut",
      "poi_latitude": "35.593166",
      "poi_longitude": "-82.55094299999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-575-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXzYq41nzWYgRmy6GPmXlimQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a76fc7e2-332e-4bbb-a7c0-e4f94fe778cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Pizza & Brewing Co",
      "poi_type": "Restaurants",
      "poi_address": "675 Merrimon Ave, Asheville, NC 28804, USA",
      "poi_short_description": "Funky, upbeat spot specializing in locally brewed beers, starters & specialty pies.",
      "poi_long_description": "Funky, upbeat spot specializing in locally brewed beers, starters & specialty pies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-0c15-72e9-8193-349791e13d4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-0c15-72e9-8193-349791e13d4b",
        "storage_key": "property/6767906449167904/01a18e21-0c15-72e9-8193-349791e13d4b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.ashevillebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2582758664546824695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-pizza--brewing-co",
      "poi_latitude": "35.622105",
      "poi_longitude": "-82.553709",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 828-254-5339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8a5-740d-be7d-76ed6377d80d",
        "storage_key": "property/6767906449167904/01a1795e-f8a5-740d-be7d-76ed6377d80d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqX9-U8j0WYgR9zHgRFLN1yM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_94704984-7b1a-42f8-aae1-4fb1cc06b758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1636 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Comprehensive department store offering a wide selection of electronics, home goods, and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-bcaf-770f-aff1-819fcee44e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-bcaf-770f-aff1-819fcee44e7d",
        "storage_key": "property/6767906449167904/01a17960-bcaf-770f-aff1-819fcee44e7d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4428-asheville-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17672220882622254750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.513509500000005",
      "poi_longitude": "-82.5238128",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 828-333-9505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-06ccad82dc49",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy_bNB4PyWYgRno7w5EJXQPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_685c062c-70a2-4754-98bf-a646e48f1866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1378 Hendersonville Rd H, Asheville, NC 28803, USA",
      "poi_short_description": "Upscale grocery store chain with an old-world vibe offers local produce, prepared eats, wine & more.",
      "poi_long_description": "Upscale grocery store chain with an old-world vibe offers local produce, prepared eats, wine & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-d1ca-724e-b725-5e59defc729d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-d1ca-724e-b725-5e59defc729d",
        "storage_key": "property/6767906449167904/01a17960-d1ca-724e-b725-5e59defc729d.webp",
        "width": 1280,
        "height": 690
      },
      "poi_business_url": "https://stores.thefreshmarket.com/nc/asheville/189",
      "poi_directions_map_url": "https://maps.google.com/?cid=8324819732898360597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fresh-market",
      "poi_latitude": "35.523368999999995",
      "poi_longitude": "-82.529068",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 828-277-7023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-0b47a40c5a3c",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYI1M47yWYgRFa2RtnCzh3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8f442a85-b38c-4372-badf-481548453ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1856 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-31da-7639-94d3-e804eb2dc114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-31da-7639-94d3-e804eb2dc114",
        "storage_key": "property/6767906449167904/01a17961-31da-7639-94d3-e804eb2dc114.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/southasheville?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001626",
      "poi_directions_map_url": "https://maps.google.com/?cid=17708431478906285998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5011272",
      "poi_longitude": "-82.5213299",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-378-0477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-0b47a40c5a3c",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK69dYeDtWYgRru-NVZv8wPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_df38f291-ea0b-4cc7-b44a-ff5e121adb47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Publix Super Market at Pinnacle Point",
      "poi_type": "Shopping & Retail",
      "poi_address": "1830 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-df7f-73bd-83da-0ad3de299c3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-df7f-73bd-83da-0ad3de299c3f",
        "storage_key": "property/6767906449167904/01a17960-df7f-73bd-83da-0ad3de299c3f.webp",
        "width": 1279,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1473&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=1695001925988024970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-pinnacle-point",
      "poi_latitude": "35.5047193",
      "poi_longitude": "-82.5223328",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-274-6287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-0b47a40c5a3c",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk0OG6n7tWYgRioIebEXbhRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_31618f5b-314e-42b7-894e-133e0ae64b0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1835 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-ea66-73b6-8b9e-5fa6a94b4f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-ea66-73b6-8b9e-5fa6a94b4f47",
        "storage_key": "property/6767906449167904/01a17960-ea66-73b6-8b9e-5fa6a94b4f47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1835+hendersonville+rd-asheville-nc-28803/id=7823",
      "poi_directions_map_url": "https://maps.google.com/?cid=9625768330804659655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.502703499999996",
      "poi_longitude": "-82.5241422",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 828-274-7560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV949WXntWYgRxwXRH0yZlYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_eb9a0776-b041-4b6b-9c56-8d37ba35145c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1080 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17960-d99a-7697-8ee6-928acb8e8b91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-d99a-7697-8ee6-928acb8e8b91",
        "storage_key": "property/6767906449167904/01a17960-d99a-7697-8ee6-928acb8e8b91.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/asheville-nc-pharmacies/1080-hendersonville-road-asheville-nc-28803/storeid=4105?WT.mc_id=LS_GOOGLE_RX_4105",
      "poi_directions_map_url": "https://maps.google.com/?cid=9150921788638507489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.5362039",
      "poi_longitude": "-82.528269",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 828-274-3631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6b-72b4-8c33-e11d863c15e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-e11d863c15e7",
        "storage_key": "property/6767906449167904/01a17965-de6b-72b4-8c33-e11d863c15e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4YmGfLyWYgR4TEuE-Ka_n4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9fffee4a-268f-478b-9c8c-dc10454cbbde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "MAHEC Community Pharmacy at Biltmore",
      "poi_type": "Health and Wellness",
      "poi_address": "125 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17963-4af9-7487-99af-12ba2bdb64de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17963-4af9-7487-99af-12ba2bdb64de",
        "storage_key": "property/6767906449167904/01a17963-4af9-7487-99af-12ba2bdb64de.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.mahec.net/pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=5658597120499622420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahec-community-pharmacy-at-biltmore",
      "poi_latitude": "35.561349",
      "poi_longitude": "-82.5440158",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 828-579-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6b-72b4-8c33-e11d863c15e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-e11d863c15e7",
        "storage_key": "property/6767906449167904/01a17965-de6b-72b4-8c33-e11d863c15e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3G3FALzWYgRFKJtvhlgh04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_767276af-f9b9-4a83-9ef7-0c8d16fff0a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asiana Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1968 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Japanese & South Asian fare, including sushi, served from multiple buffets, with takeout available.",
      "poi_long_description": "Japanese & South Asian fare, including sushi, served from multiple buffets, with takeout available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1265-7067-b316-791c1c589377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1265-7067-b316-791c1c589377",
        "storage_key": "property/6767906449167904/01a18e21-1265-7067-b316-791c1c589377.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://asianamarketavl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10649176438049200635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asiana-market",
      "poi_latitude": "35.4905428",
      "poi_longitude": "-82.5220198",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 828-585-2362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-0b47a40c5a3c",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNauYenTtWYgR-9lhdIx5yZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_bd75c581-04dc-4f62-9cec-0b378eade033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 River Hills Rd, Asheville, NC 28805, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-61b5-75f6-9bed-aee75e2c4dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-61b5-75f6-9bed-aee75e2c4dab",
        "storage_key": "property/6767906449167904/01a17961-61b5-75f6-9bed-aee75e2c4dab.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/asheville/1807",
      "poi_directions_map_url": "https://maps.google.com/?cid=11970717299828174679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.5735709",
      "poi_longitude": "-82.5223783",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 828-298-1262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-06ccad82dc49",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUag8OQvzWYgRV6_h6vWHIKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_53885ae3-c714-4008-b774-e897e583cdb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "480 Swannanoa River Rd, Asheville, NC 28805, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-12ce-772b-bf3f-a5503b2ce3e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-12ce-772b-bf3f-a5503b2ce3e8",
        "storage_key": "property/6767906449167904/01a18e21-12ce-772b-bf3f-a5503b2ce3e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.aldi.us/store/aldi/pages/locator/l/nc/asheville/480-swannanoa-river-road/l949",
      "poi_directions_map_url": "https://maps.google.com/?cid=881611370763092899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.577946",
      "poi_longitude": "-82.511248",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-0b47a40c5a3c",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-0b47a40c5a3c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8-dOzzX54kRo4NH6N4cPAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_ec40b612-6de8-4595-9bc2-8b75d71b6787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Charles T. Koontz Intermediate School",
      "poi_type": "Education",
      "poi_address": "305 Overlook Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-9836-7099-ae83-99cab36762b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-9836-7099-ae83-99cab36762b8",
        "storage_key": "property/6767906449167904/01a17961-9836-7099-ae83-99cab36762b8.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://ctkis.buncombeschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10488261759827057283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-t-koontz-intermediate-school",
      "poi_latitude": "35.483991599999996",
      "poi_longitude": "-82.53971",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 828-684-1295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM9un_XHtWYgRgxrOWYDKjZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_08c02927-ec65-4f28-8bb5-4e27290f7d76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "William W. Estes Elementary School",
      "poi_type": "Education",
      "poi_address": "275 Overlook Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-d44d-75ec-ba82-8ac2f568afa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-d44d-75ec-ba82-8ac2f568afa9",
        "storage_key": "property/6767906449167904/01a17961-d44d-75ec-ba82-8ac2f568afa9.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "https://wwees.buncombeschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2433771271529010666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-w-estes-elementary-school",
      "poi_latitude": "35.487882899999995",
      "poi_longitude": "-82.539873",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 828-654-1795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa5IxKRXtWYgR6pUJqBN-xiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_77bbb204-a24f-4eb6-9d1a-ff712cdabd66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "T.C. Roberson High School",
      "poi_type": "Education",
      "poi_address": "250 Overlook Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-b19f-70fe-91a3-e0e004e95169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-b19f-70fe-91a3-e0e004e95169",
        "storage_key": "property/6767906449167904/01a17961-b19f-70fe-91a3-e0e004e95169.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tcrhs.buncombeschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13759669282674360671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tc-roberson-high-school",
      "poi_latitude": "35.4859607",
      "poi_longitude": "-82.535049",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 828-654-1765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf_chQfHtWYgRX8GojE8q9L4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_62bea241-477b-4727-864a-4ccc6e4716c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Valley Springs Middle School",
      "poi_type": "Education",
      "poi_address": "224 Long Shoals Rd, Arden, NC 28704, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-b4a6-749a-8478-8187ad94c94d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-b4a6-749a-8478-8187ad94c94d",
        "storage_key": "property/6767906449167904/01a17961-b4a6-749a-8478-8187ad94c94d.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://vsms.buncombeschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15912270444295469465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-springs-middle-school",
      "poi_latitude": "35.4850207",
      "poi_longitude": "-82.5411943",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 828-654-1785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaSRoOj7tWYgRmbktiqm909w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3de91f05-a3a0-437c-8bdd-2500ed6a4e83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville-Buncombe Technical Community College",
      "poi_type": "Education",
      "poi_address": "340 Victoria Rd, Asheville, NC 28801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-5a45-7606-80eb-6516042be39e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-5a45-7606-80eb-6516042be39e",
        "storage_key": "property/6767906449167904/01a17962-5a45-7606-80eb-6516042be39e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.abtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10908704105296374311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-buncombe-technical-community-college",
      "poi_latitude": "35.570664199999996",
      "poi_longitude": "-82.5555519",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-398-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45uiqDbzWYgRJyoJRJaAY5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_30f5ea12-998d-4654-b953-8cb47d6d58fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "University of North Carolina Asheville",
      "poi_type": "Education",
      "poi_address": "1 University Heights, Asheville, NC 28804, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-ec94-776f-95ad-ed8d27ea6da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-ec94-776f-95ad-ed8d27ea6da7",
        "storage_key": "property/6767906449167904/01a17961-ec94-776f-95ad-ed8d27ea6da7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unca.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13736592848407480060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-asheville",
      "poi_latitude": "35.6170787",
      "poi_longitude": "-82.5665332",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 828-251-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_____8_0WYgR_MZ_gWouor4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ae09cf6b-b81d-4eb9-b401-c829ace40b3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Carolina Day School",
      "poi_type": "Education",
      "poi_address": "1345 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-8b5d-727f-b6dc-31ac2e84b76c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-8b5d-727f-b6dc-31ac2e84b76c",
        "storage_key": "property/6767906449167904/01a17961-8b5d-727f-b6dc-31ac2e84b76c.webp",
        "width": 1280,
        "height": 1041
      },
      "poi_business_url": "https://www.carolinaday.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6879092127586053718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolina-day-school",
      "poi_latitude": "35.522946499999996",
      "poi_longitude": "-82.53114169999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 828-274-0757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_J9JZDyWYgRVu7z0ddxd18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4453360a-c168-4709-823a-142367baafe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Zaniac Learning Center",
      "poi_type": "Education",
      "poi_address": "1 Town Square Blvd #120, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1451-73b6-9152-324ff1484fce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1451-73b6-9152-324ff1484fce",
        "storage_key": "property/6767906449167904/01a18e21-1451-73b6-9152-324ff1484fce.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.zaniaclearning.com/asheville",
      "poi_directions_map_url": "https://maps.google.com/?cid=2106410620882612084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zaniac-learning-center",
      "poi_latitude": "35.4864204",
      "poi_longitude": "-82.55453179999999",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 828-575-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM5SF-DbtWYgRdG_RqEx5Ox0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_4a60443d-2fb6-4c1e-b9c8-9ddb7dd01634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Mountain Child Advocacy Center",
      "poi_type": "Education",
      "poi_address": "11 Vanderbilt Park Dr Ste A, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-14fe-705f-bae7-ebd654e3a1b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-14fe-705f-bae7-ebd654e3a1b4",
        "storage_key": "property/6767906449167904/01a18e21-14fe-705f-bae7-ebd654e3a1b4.webp",
        "width": 1280,
        "height": 499
      },
      "poi_business_url": "http://www.mtncac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9858293505987200617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-child-advocacy-center",
      "poi_latitude": "35.557551",
      "poi_longitude": "-82.5426686",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 828-213-9824",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYy5mVPzWYgRaUboU7axz4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_169a9e41-d8a6-4e0c-8630-6ace14ed3ef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The Academy of Asheville",
      "poi_type": "Education",
      "poi_address": "1709 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Well-regarded day care center focusing on kindergarten readiness and providing healthy meals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-db58-73ee-b407-f600b0ca827a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-db58-73ee-b407-f600b0ca827a",
        "storage_key": "property/6767906449167904/01a17961-db58-73ee-b407-f600b0ca827a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cadence-education.com/locations/nc/asheville/724/?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=15673170866945731305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-academy-of-asheville",
      "poi_latitude": "35.509063",
      "poi_longitude": "-82.5268048",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-710-0075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ0RhvYHyWYgR6SpNDN1Jgtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_5243073c-df6f-425d-8373-cd44dad75087",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The Orange Peel",
      "poi_type": "Entertainment",
      "poi_address": "101 Biltmore Ave, Asheville, NC 28801, USA",
      "poi_short_description": "This popular, stylish performance site for local & national musicians offers a full bar downstairs.",
      "poi_long_description": "This popular, stylish performance site for local & national musicians offers a full bar downstairs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-679c-77c5-b00c-94718c177828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-679c-77c5-b00c-94718c177828",
        "storage_key": "property/6767906449167904/01a17962-679c-77c5-b00c-94718c177828.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://theorangepeel.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16930085651688998956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-orange-peel",
      "poi_latitude": "35.5914061",
      "poi_longitude": "-82.5510137",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-398-1837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6a-741e-9bd1-153aafa36bfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6a-741e-9bd1-153aafa36bfa",
        "storage_key": "property/6767906449167904/01a17965-de6a-741e-9bd1-153aafa36bfa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDQoFDzWYgRLEjcZTO_8-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_5e1630b6-9fe3-4fad-aa52-d8ea9af64bd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "2 S Pack Square, Asheville, NC 28801, USA",
      "poi_short_description": "Collection of American art from the 20th & 21st centuries, plus art-related programs for all ages.",
      "poi_long_description": "Collection of American art from the 20th & 21st centuries, plus art-related programs for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-8f66-728f-a7c3-49e28fa8cbf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-8f66-728f-a7c3-49e28fa8cbf6",
        "storage_key": "property/6767906449167904/01a17962-8f66-728f-a7c3-49e28fa8cbf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ashevilleart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17643787816291928326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-art-museum",
      "poi_latitude": "35.594671399999996",
      "poi_longitude": "-82.5512827",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 828-253-3227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f91e-777b-945e-38205209d918.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f91e-777b-945e-38205209d918",
        "storage_key": "property/6767906449167904/01a1795e-f91e-777b-945e-38205209d918.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs6F9fFfzWYgRBglywolT2_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_ef7712fb-80ae-4f85-8b20-64ac58a01f52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Biltmore",
      "poi_type": "Entertainment",
      "poi_address": "Asheville, NC 28803, USA",
      "poi_short_description": "George W. Vanderbilt’s iconic French Renaissance château features 250 rooms, lavish gardens & tours.",
      "poi_long_description": "George W. Vanderbilt’s iconic French Renaissance château features 250 rooms, lavish gardens & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-14be-7243-abfa-29e1292de848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-14be-7243-abfa-29e1292de848",
        "storage_key": "property/6767906449167904/01a18e21-14be-7243-abfa-29e1292de848.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.biltmore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10544340077709678197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biltmore",
      "poi_latitude": "35.5527514",
      "poi_longitude": "-82.56369049999999",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-411-3812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6b-72b4-8c33-e8c8e44d5ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-e8c8e44d5ac9",
        "storage_key": "property/6767906449167904/01a17965-de6b-72b4-8c33-e8c8e44d5ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs183vc_yWYgRddbMMm8FVZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_3341ec6c-ddb9-4903-b180-1de430b04c24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Western North Carolina Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "75 Gashes Creek Rd, Asheville, NC 28805, USA",
      "poi_short_description": "A zoo exploring flora & fauna of the Southern Appalachian region, with more than 60 animal species.",
      "poi_long_description": "A zoo exploring flora & fauna of the Southern Appalachian region, with more than 60 animal species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e1f-511e-723c-8337-75406ba696f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e1f-511e-723c-8337-75406ba696f0",
        "storage_key": "property/6767906449167904/01a18e1f-511e-723c-8337-75406ba696f0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wildwnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1076559306256338733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-north-carolina-nature-center",
      "poi_latitude": "35.5794378",
      "poi_longitude": "-82.4942607",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-259-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f91e-777b-945e-3d6e6d4ddbf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f91e-777b-945e-3d6e6d4ddbf1",
        "storage_key": "property/6767906449167904/01a1795e-f91e-777b-945e-3d6e6d4ddbf1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK6H_L-vzWYgRLc8MNfy08A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_3e4fc7a5-9301-4d25-a51b-524a5bac40c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Regal Biltmore Grande",
      "poi_type": "Entertainment",
      "poi_address": "292 Thetford St, Asheville, NC 28803, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-6f75-708b-9de4-2bdb1bdaa387.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-6f75-708b-9de4-2bdb1bdaa387",
        "storage_key": "property/6767906449167904/01a17962-6f75-708b-9de4-2bdb1bdaa387.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-biltmore-grande-rpx-1892?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14931773072272260661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-biltmore-grande",
      "poi_latitude": "35.48489",
      "poi_longitude": "-82.55788",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6b-72b4-8c33-e676256a4580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-e676256a4580",
        "storage_key": "property/6767906449167904/01a17965-de6b-72b4-8c33-e676256a4580.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8hlBjTtWYgRNf6HT39QOM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c81685fa-0541-4675-9bb2-9f2a37b46268",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The Grey Eagle Music Hall and Pub",
      "poi_type": "Entertainment",
      "poi_address": "185 Clingman Ave Ext, Asheville, NC 28801, USA",
      "poi_short_description": "Mellow all-ages destination for live music & innovative Latin cuisine with a roomy outdoor patio.",
      "poi_long_description": "Mellow all-ages destination for live music & innovative Latin cuisine with a roomy outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-16a3-75f0-b0ae-f870b4c080e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-16a3-75f0-b0ae-f870b4c080e4",
        "storage_key": "property/6767906449167904/01a18e21-16a3-75f0-b0ae-f870b4c080e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thegreyeagle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9437450490515184699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-grey-eagle-music-hall-and-pub",
      "poi_latitude": "35.5870871",
      "poi_longitude": "-82.5643936",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 828-232-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6a-741e-9bd1-153aafa36bfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6a-741e-9bd1-153aafa36bfa",
        "storage_key": "property/6767906449167904/01a17965-de6a-741e-9bd1-153aafa36bfa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeWkh7KMWYgRO1x-KDiP-II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_0d151dd6-520e-4500-a2e0-e95b41723e8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Pinball Museum",
      "poi_type": "Entertainment",
      "poi_address": "1 Battle Square Ste 1b, Asheville, NC 28801, USA",
      "poi_short_description": "All-you-can-play arcade featuring 75+ pinball machines & classic video games, plus beer & soda.",
      "poi_long_description": "All-you-can-play arcade featuring 75+ pinball machines & classic video games, plus beer & soda.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-8b25-7366-a2a3-ad05f7a31a23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-8b25-7366-a2a3-ad05f7a31a23",
        "storage_key": "property/6767906449167904/01a17962-8b25-7366-a2a3-ad05f7a31a23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ashevillepinball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14820618794652127948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-pinball-museum",
      "poi_latitude": "35.5964044",
      "poi_longitude": "-82.55665839999999",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 828-776-5671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f91e-777b-945e-38205209d918.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f91e-777b-945e-38205209d918",
        "storage_key": "property/6767906449167904/01a1795e-f91e-777b-945e-38205209d918.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_WS21XzWYgRzNK3TkVqrc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c58bf451-bac7-4bee-aa99-82dabf3612f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Fine Arts Theatre",
      "poi_type": "Entertainment",
      "poi_address": "36 Biltmore Ave, Asheville, NC 28801, USA",
      "poi_short_description": "Easygoing cinema showing 1st-run, art & independent films in an art deco/modern setting.",
      "poi_long_description": "Easygoing cinema showing 1st-run, art & independent films in an art deco/modern setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-b2f9-7113-919a-fdc94626b40e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-b2f9-7113-919a-fdc94626b40e",
        "storage_key": "property/6767906449167904/01a17962-b2f9-7113-919a-fdc94626b40e.webp",
        "width": 987,
        "height": 987
      },
      "poi_business_url": "http://fineartstheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8116050402640468741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fine-arts-theatre",
      "poi_latitude": "35.593571",
      "poi_longitude": "-82.551125",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-232-1536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6b-72b4-8c33-e676256a4580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-e676256a4580",
        "storage_key": "property/6767906449167904/01a17965-de6b-72b4-8c33-e676256a4580.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcIj4lnzWYgRBRuNLNcAonA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e28107ba-551e-4794-9103-fdf5e06a1f95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "31 Patton Ave, Asheville, NC 28801, USA",
      "poi_short_description": "Popular watering hole with a lively dance floor & an eclectic line-up of local & touring acts.",
      "poi_long_description": "Popular watering hole with a lively dance floor & an eclectic line-up of local & touring acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-175b-711c-940e-9e6c53ba4a31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-175b-711c-940e-9e6c53ba4a31",
        "storage_key": "property/6767906449167904/01a18e21-175b-711c-940e-9e6c53ba4a31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ashevillemusichall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=928712432479243960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-music-hall",
      "poi_latitude": "35.5948675",
      "poi_longitude": "-82.5530254",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 828-255-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6a-741e-9bd1-153aafa36bfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6a-741e-9bd1-153aafa36bfa",
        "storage_key": "property/6767906449167904/01a17965-de6a-741e-9bd1-153aafa36bfa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RgwZNm1JhURuA5qbAlz4ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_1d5b5576-e16e-442a-ac85-637d7ce776f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Grove Arcade",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Page Ave, Asheville, NC 28801, USA",
      "poi_short_description": "Historic shopping and dining destination featuring ornate architecture and a variety of local boutiques and artisan shops.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1a95-7109-8f6c-56b23d97d2aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1a95-7109-8f6c-56b23d97d2aa",
        "storage_key": "property/6767906449167904/01a18e21-1a95-7109-8f6c-56b23d97d2aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://grovearcade.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10155512775198940464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grove-arcade",
      "poi_latitude": "35.595614999999995",
      "poi_longitude": "-82.5566561",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-252-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f91e-777b-945e-38205209d918.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f91e-777b-945e-38205209d918",
        "storage_key": "property/6767906449167904/01a1795e-f91e-777b-945e-38205209d918.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZTe1FXzWYgRMJ2sFRCh74w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_45335dca-69a7-4d46-b7d7-894b9a1bac4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Mission Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "509 Biltmore Ave, Asheville, NC 28801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795b-43ec-7682-a3a3-0c154b4a95cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795b-43ec-7682-a3a3-0c154b4a95cd",
        "storage_key": "property/6767906449167904/01a1795b-43ec-7682-a3a3-0c154b4a95cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.missionhealth.org/locations/mission-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13697098163233844625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-hospital",
      "poi_latitude": "35.576583",
      "poi_longitude": "-82.54922200000001",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-213-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f925-71aa-bfc6-712d1b9797b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f925-71aa-bfc6-712d1b9797b6",
        "storage_key": "property/6767906449167904/01a1795e-f925-71aa-bfc6-712d1b9797b6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZAUCUbzWYgRkW01iTXeFb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1295bce2-e59a-455e-8489-39d1a16dbb59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "FastMed Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "160 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1a0d-74d3-a370-5118da46b285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1a0d-74d3-a370-5118da46b285",
        "storage_key": "property/6767906449167904/01a18e21-1a0d-74d3-a370-5118da46b285.webp",
        "width": 996,
        "height": 655
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/asheville-nc-walk-in-clinic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16621410805684397131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fastmed-urgent-care",
      "poi_latitude": "35.5642597",
      "poi_longitude": "-82.5418759",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 828-210-2835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS38yyLzWYgRS2SoUhAdq-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_0f522d8d-5fbe-49fe-a005-1579022eb71c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Mercy Urgent Care South Asheville",
      "poi_type": "Health and Wellness",
      "poi_address": "1833 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1a50-724f-acdb-dd79755072fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1a50-724f-acdb-dd79755072fc",
        "storage_key": "property/6767906449167904/01a18e21-1a50-724f-acdb-dd79755072fc.webp",
        "width": 918,
        "height": 1024
      },
      "poi_business_url": "http://mercyurgentcare.org/south-asheville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18135682420942041876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-urgent-care-south-asheville",
      "poi_latitude": "35.503092699999996",
      "poi_longitude": "-82.5244178",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-274-1462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT8kg67tWYgRFPOLKxPjrvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_29210df9-5ff6-4973-a44a-71d62c6432b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Publix Pharmacy at Pinnacle Point",
      "poi_type": "Health and Wellness",
      "poi_address": "1830 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17962-f43e-761f-b646-05da08b17cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-f43e-761f-b646-05da08b17cf3",
        "storage_key": "property/6767906449167904/01a17962-f43e-761f-b646-05da08b17cf3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=5063277414840869413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-pinnacle-point",
      "poi_latitude": "35.5047448",
      "poi_longitude": "-82.52233989999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-274-6293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6b-72b4-8c33-e11d863c15e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-e11d863c15e7",
        "storage_key": "property/6767906449167904/01a17965-de6b-72b4-8c33-e11d863c15e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVVa637tWYgRJSLZfvtfREY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e30afcfa-084e-4641-8057-313f2d152018",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1816 Hendersonville Rd #60, Asheville, NC 28803, USA",
      "poi_short_description": "Welcoming gym offering heart rate-monitored, structured group fitness workouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17963-76c2-75ce-b7b6-741df7c84099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17963-76c2-75ce-b7b6-741df7c84099",
        "storage_key": "property/6767906449167904/01a17963-76c2-75ce-b7b6-741df7c84099.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/asheville-north-carolina-0650?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=5342362937914799441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.5053141",
      "poi_longitude": "-82.52284879999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-610-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX85AjX7tWYgRUbWfd8niI0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e55fb73-46a7-437d-a9e9-f51340d906b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Pure Barre Asheville",
      "poi_type": "Health and Wellness",
      "poi_address": "1863 Hendersonville Rd Suite 114, Asheville, NC 28803, USA",
      "poi_short_description": "Welcoming fitness studio offering low-impact, full-body workouts inspired by yoga, Pilates, and ballet.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1c6e-757e-ba8c-a2cd5515f42f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1c6e-757e-ba8c-a2cd5515f42f",
        "storage_key": "property/6767906449167904/01a18e21-1c6e-757e-ba8c-a2cd5515f42f.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.purebarre.com/location/asheville-nc/?utm_source=google&utm_medium=organic&utm_campaign=GPBListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8065421190193203874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre-asheville",
      "poi_latitude": "35.501002799999995",
      "poi_longitude": "-82.5240505",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 828-274-6595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ84uBtxj584gRospfDdch7m8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_9e978e0d-ecd5-4b9d-9872-04d9d9d4c822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1863 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Well-maintained, 24/7 fitness center featuring modern equipment and private shower facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1d47-75eb-97ab-532893db7e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1d47-75eb-97ab-532893db7e86",
        "storage_key": "property/6767906449167904/01a18e21-1d47-75eb-97ab-532893db7e86.webp",
        "width": 1280,
        "height": 1001
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/asheville-north-carolina-3299/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3299",
      "poi_directions_map_url": "https://maps.google.com/?cid=11664941342184283972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.501700899999996",
      "poi_longitude": "-82.52385509999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 828-920-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_Tz1HvtWYgRRJ-p4lgy4qE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6ce215d6-bd91-4914-a961-fd73df507796",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Yoga Center",
      "poi_type": "Health and Wellness",
      "poi_address": "211 S Liberty St, Asheville, NC 28801, USA",
      "poi_short_description": "Welcoming yoga studio featuring a wide variety of classes and professional teacher training programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795b-a898-700d-9393-35bb871a4c9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795b-a898-700d-9393-35bb871a4c9f",
        "storage_key": "property/6767906449167904/01a1795b-a898-700d-9393-35bb871a4c9f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://youryoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1190050139277312075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-yoga-center",
      "poi_latitude": "35.6021595",
      "poi_longitude": "-82.5513192",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-254-0380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f920-7239-8d9d-a4333078972c",
        "storage_key": "property/6767906449167904/01a1795e-f920-7239-8d9d-a4333078972c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgWQirqj0WYgRS0CH6EvogxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c7dcfa13-879b-4c4e-b1cc-b134ff5a4767",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Julian Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "406 Overlook Rd Ext, Arden, NC 28704, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1f64-7348-867e-941f6630cb39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1f64-7348-867e-941f6630cb39",
        "storage_key": "property/6767906449167904/01a18e21-1f64-7348-867e-941f6630cb39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3878924097984446944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julian-lake-park",
      "poi_latitude": "35.480314",
      "poi_longitude": "-82.53943699999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8pMMsTtWYgR4MEQa-q01DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_b61397cc-d2c0-4505-93a6-21a030caea31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Corcoran Paige River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9 Pinner Rd, Arden, NC 28704, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-1f55-77d1-ae92-dbc22ecba698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-1f55-77d1-ae92-dbc22ecba698",
        "storage_key": "property/6767906449167904/01a18e21-1f55-77d1-ae92-dbc22ecba698.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.buncombenc.gov/368/River-Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17032788860203748852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corcoran-paige-river-park",
      "poi_latitude": "35.454755",
      "poi_longitude": "-82.54701999999999",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-250-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-1dc0-777c-b1c2-fb830fce6574",
        "storage_key": "property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7_0OwMTsWYgR9M2sijmfYOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f3e3fc14-e9c5-4621-b483-aa653c727d36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Glen Bridge River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "77 Pinner Rd, Arden, NC 28704, USA",
      "poi_short_description": "Park featuring picnic tables and grills, plus river access for rafting, kayaking and fishing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-22ab-730c-9eee-85236a6c1ed8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-22ab-730c-9eee-85236a6c1ed8",
        "storage_key": "property/6767906449167904/01a18e21-22ab-730c-9eee-85236a6c1ed8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.buncombenc.gov/368/River-Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=5883228347553034494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glen-bridge-river-park",
      "poi_latitude": "35.450902",
      "poi_longitude": "-82.55511299999999",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-250-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-1dc0-777c-b1c2-fb830fce6574",
        "storage_key": "property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYB3SsnsWYgR_jBo7AJtpVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e7e86fb5-0c79-4649-8a59-50d5102a2a51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Bent Creek River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1610 Brevard Rd, Asheville, NC 28806, USA",
      "poi_short_description": "Scenic riverfront park featuring boat launch access and picnic areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-20d1-74ba-a8bd-cef4d70a5e13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-20d1-74ba-a8bd-cef4d70a5e13",
        "storage_key": "property/6767906449167904/01a18e21-20d1-74ba-a8bd-cef4d70a5e13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.buncombenc.gov/Facilities/Facility/Details/Bent-Creek-River-Park-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=12151888440890049258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bent-creek-river-park",
      "poi_latitude": "35.501498999999995",
      "poi_longitude": "-82.593132",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 828-250-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-1dc0-777c-b1c2-fb830fce6574",
        "storage_key": "property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxPsOYWSWYgR6kJtTScupKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d356b5d7-990a-4497-8ec8-f8e405163676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Lake Powhatan Recreation Area & Campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "375 Wesley Branch Rd, Asheville, NC 28806, USA",
      "poi_short_description": "Lakeside camping & glamping sites open April to October with a beach, hot showers & picnic areas.",
      "poi_long_description": "Lakeside camping & glamping sites open April to October with a beach, hot showers & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-20af-75ff-a37b-ce47ca0a893a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-20af-75ff-a37b-ce47ca0a893a",
        "storage_key": "property/6767906449167904/01a18e21-20af-75ff-a37b-ce47ca0a893a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.recreation.gov/camping/campgrounds/231995",
      "poi_directions_map_url": "https://maps.google.com/?cid=5854370562347812507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-powhatan-recreation-area--campground",
      "poi_latitude": "35.4862369",
      "poi_longitude": "-82.62745869999999",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 828-577-7278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-45b1-7418-b43c-ab15f47098dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a18e21-45b1-7418-b43c-ab15f47098dd",
        "storage_key": "property/6767906449167904/01a18e21-45b1-7418-b43c-ab15f47098dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb290sGmSWYgRm8Y-OALnPlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_7f07058c-8ae0-4299-aad8-1b6005047dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The North Carolina Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20 Frederick Law Olmsted Way, Asheville, NC 28806, USA",
      "poi_short_description": "Arboretum in a forest with mountain views, gardens & a bonsai exhibit, plus hiking & biking paths.",
      "poi_long_description": "Arboretum in a forest with mountain views, gardens & a bonsai exhibit, plus hiking & biking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795d-b9e9-77bd-a9b5-b059b704d33f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795d-b9e9-77bd-a9b5-b059b704d33f",
        "storage_key": "property/6767906449167904/01a1795d-b9e9-77bd-a9b5-b059b704d33f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.ncarboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5009625258165182315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-north-carolina-arboretum",
      "poi_latitude": "35.495852",
      "poi_longitude": "-82.605223",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 828-665-2492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f92c-7577-9477-6e8790b187a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f92c-7577-9477-6e8790b187a1",
        "storage_key": "property/6767906449167904/01a1795e-f92c-7577-9477-6e8790b187a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOwpm7o-SWYgRa5_CUqHDhUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_a009f3dd-0a96-4980-977e-500ac9a4d97f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Blue Ridge Parkway Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "195 Hemphill Knob Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Informative parkway visitor center featuring educational exhibits and travel resources.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-2447-76ff-91c1-6e07042aaf29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-2447-76ff-91c1-6e07042aaf29",
        "storage_key": "property/6767906449167904/01a18e21-2447-76ff-91c1-6e07042aaf29.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nps.gov/blri/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=17121966133559936996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-ridge-parkway-visitor-center",
      "poi_latitude": "35.5658059",
      "poi_longitude": "-82.4863211",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 23 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 828-298-5330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-45b0-73f6-bb43-d4a5fa8e7b63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a18e21-45b0-73f6-bb43-d4a5fa8e7b63",
        "storage_key": "property/6767906449167904/01a18e21-45b0-73f6-bb43-d4a5fa8e7b63.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJoy-s6cTzWYgR5Mcbf3txne0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_9ff28273-721a-42bc-a2ac-19558e124874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The Inn on Biltmore Estate",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Antler Hill Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Posh rooms in a luxe hotel on the iconic Vanderbilt estate with fine dining, an outdoor pool & spa.",
      "poi_long_description": "Posh rooms in a luxe hotel on the iconic Vanderbilt estate with fine dining, an outdoor pool & spa.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-2262-7261-b48e-7a05caf76671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-2262-7261-b48e-7a05caf76671",
        "storage_key": "property/6767906449167904/01a18e21-2262-7261-b48e-7a05caf76671.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.biltmore.com/stay",
      "poi_directions_map_url": "https://maps.google.com/?cid=4912112184644242724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-inn-on-biltmore-estate",
      "poi_latitude": "35.5577866",
      "poi_longitude": "-82.5805968",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-411-3812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-45b1-7418-b43c-a54694d4c9ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a18e21-45b1-7418-b43c-a54694d4c9ca",
        "storage_key": "property/6767906449167904/01a18e21-45b1-7418-b43c-a54694d4c9ca.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ2xdFCt-MWYgRJI2WpgFUK0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_9b5ae664-2e52-430e-9b4f-71c9d0476992",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Biltmore Park Town Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "One Town Square Blvd, Asheville, NC 28803, USA",
      "poi_short_description": "Vibrant, upscale mall featuring retail stores, boutiques, ranging restaurants & a movie theater.",
      "poi_long_description": "Vibrant, upscale mall featuring retail stores, boutiques, ranging restaurants & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17961-2ba0-718d-ba81-88ea3b6f079b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-2ba0-718d-ba81-88ea3b6f079b",
        "storage_key": "property/6767906449167904/01a17961-2ba0-718d-ba81-88ea3b6f079b.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://biltmorepark.com/?utm_source=google&utm_medium=local&utm_campaign=google_my_business&utm_content=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3798664365216352068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biltmore-park-town-square",
      "poi_latitude": "35.485383",
      "poi_longitude": "-82.5553114",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-209-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-06ccad82dc49",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbeE8XzbtWYgRRMenLR2RtzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8aa29d2a-9600-4b98-ba1a-db8f89e791a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Kenilworth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "79 Wyoming Rd, Asheville, NC 28803, USA",
      "poi_short_description": "Charming neighborhood park featuring a playground and sports courts for basketball, tennis, and soccer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-2710-7148-bd6b-aaf005faed7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-2710-7148-bd6b-aaf005faed7e",
        "storage_key": "property/6767906449167904/01a18e21-2710-7148-bd6b-aaf005faed7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ashevillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5883683919664539456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenilworth-park",
      "poi_latitude": "35.577736",
      "poi_longitude": "-82.542047",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-350-2051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-1dc0-777c-b1c2-fb830fce6574",
        "storage_key": "property/6767906449167904/01a1795f-1dc0-777c-b1c2-fb830fce6574.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_9ACT0DzWYgRQGdIEloLp1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d47052b1-7a10-40ae-975c-63c47045e372",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "ART Station (on Coxe Ave)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Asheville, NC 28801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1343744484037691209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "art-station-on-coxe-ave",
      "poi_latitude": "35.5928021",
      "poi_longitude": "-82.5551653",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-45b0-73f6-bb43-daa10c921d60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a18e21-45b0-73f6-bb43-daa10c921d60",
        "storage_key": "property/6767906449167904/01a18e21-45b0-73f6-bb43-daa10c921d60.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUgGVVHzWYgRSQf1H33wpRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_d65b3b5d-880f-4a25-ba0e-1e06a6cb7977",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "Asheland Ave, Asheville, NC 28801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17964-6f3c-76a8-b3ef-b78729480836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-6f3c-76a8-b3ef-b78729480836",
        "storage_key": "property/6767906449167904/01a17964-6f3c-76a8-b3ef-b78729480836.webp",
        "width": 725,
        "height": 450
      },
      "poi_business_url": "https://www.greyhound.com/bus/asheville-nc/asheville-shell?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=17570240941438072325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "35.5895779",
      "poi_longitude": "-82.5564785",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ez_FJ70WYgRBfZwjAsJ1vM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_a04dbaa8-8d16-47df-a898-1667f2696ebe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "61 Terminal Dr #1, Fletcher, NC 28732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17964-a4af-750f-8dc3-119203e8e9e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-a4af-750f-8dc3-119203e8e9e0",
        "storage_key": "property/6767906449167904/01a17964-a4af-750f-8dc3-119203e8e9e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyavl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11129882921291387019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-regional-airport",
      "poi_latitude": "35.4348962",
      "poi_longitude": "-82.53785409999999",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 828-684-2226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-1e89-74df-a02f-cdf78dd28f60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-1e89-74df-a02f-cdf78dd28f60",
        "storage_key": "property/6767906449167904/01a1795f-1e89-74df-a02f-cdf78dd28f60.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_S6T73sWYgRi5BCW4xJdZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ca736969-2bb5-4f75-85eb-61605961a81f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Tanger Outlets Asheville",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Brevard Rd, Asheville, NC 28806, USA",
      "poi_short_description": "Expansive outlet mall featuring a wide variety of retail stores and a food court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e1f-4f6e-734e-9573-f6377769f627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e1f-4f6e-734e-9573-f6377769f627",
        "storage_key": "property/6767906449167904/01a18e1f-4f6e-734e-9573-f6377769f627.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "https://tanger.com/asheville",
      "poi_directions_map_url": "https://maps.google.com/?cid=15155474382123237015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanger-outlets-asheville",
      "poi_latitude": "35.529378799999996",
      "poi_longitude": "-82.6033834",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 828-667-2308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f8bb-720c-8d21-06ccad82dc49",
        "storage_key": "property/6767906449167904/01a1795e-f8bb-720c-8d21-06ccad82dc49.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgS5mBgCNWYgRl_78RKcPU9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_311c0e7e-6050-4ea7-bbdb-917b7b98868a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "River Ridge Dr at River Ridge Shopping Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-2724-7399-8d41-e3654c8c387c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-2724-7399-8d41-e3654c8c387c",
        "storage_key": "property/6767906449167904/01a18e21-2724-7399-8d41-e3654c8c387c.webp",
        "width": 1280,
        "height": 1101
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14627506869222464220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-ridge-dr-at-river-ridge-shopping-center",
      "poi_latitude": "35.5705879",
      "poi_longitude": "-82.506433",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-de6c-70d6-a442-709fdd966d67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6c-70d6-a442-709fdd966d67",
        "storage_key": "property/6767906449167904/01a17965-de6c-70d6-a442-709fdd966d67.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0b4JIL3zWYgR3FqXaf9X_8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_26ec448d-1a72-4983-b5ca-457cc2f7dd44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "The Biltmore Inn",
      "poi_type": "Restaurants",
      "poi_address": "One Lodge St, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-28fc-74e8-b6de-12a60a209c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-28fc-74e8-b6de-12a60a209c65",
        "storage_key": "property/6767906449167904/01a18e21-28fc-74e8-b6de-12a60a209c65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.biltmore.com/stay/inn",
      "poi_directions_map_url": "https://maps.google.com/?cid=2740875039507943881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-biltmore-inn",
      "poi_latitude": "35.5670103",
      "poi_longitude": "-82.54544829999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-411-3812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-45b1-7418-b43c-a54694d4c9ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a18e21-45b1-7418-b43c-a54694d4c9ca",
        "storage_key": "property/6767906449167904/01a18e21-45b1-7418-b43c-a54694d4c9ca.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJbXRidHrzWYgRyRGbn1OLCSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_2b47c93a-a510-44fb-9afc-d4f660d9143c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "MAHEC Family Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "123 Hendersonville Rd, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a18e21-27b0-7473-81b9-54ca857d40c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e21-27b0-7473-81b9-54ca857d40c9",
        "storage_key": "property/6767906449167904/01a18e21-27b0-7473-81b9-54ca857d40c9.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://mahec.net/family-health",
      "poi_directions_map_url": "https://maps.google.com/?cid=5352649083619331441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahec-family-health-center",
      "poi_latitude": "35.5631104",
      "poi_longitude": "-82.5428585",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 828-257-4730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwfgRrP0WYgRcU1zZPttSEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a9aca190-85df-453c-9a77-9998b4b0bcd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Charles George VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 Tunnel Rd, Asheville, NC 28805, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17964-a323-762d-97be-568a30fd71a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-a323-762d-97be-568a30fd71a3",
        "storage_key": "property/6767906449167904/01a17964-a323-762d-97be-568a30fd71a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.va.gov/asheville-health-care/locations/charles-george-department-of-veterans-affairs-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15179022984042289996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-george-va-medical-center",
      "poi_latitude": "35.588341",
      "poi_longitude": "-82.4844507",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 828-298-7911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f925-71aa-bfc6-712d1b9797b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f925-71aa-bfc6-712d1b9797b6",
        "storage_key": "property/6767906449167904/01a1795e-f925-71aa-bfc6-712d1b9797b6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJifXfjWTzWYgRTJtUafu4ptI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2ad82639-6904-4ba2-9371-817bf810f31c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Biltmore Farms, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Town Square Blvd #330, Asheville, NC 28803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.biltmorefarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4018721460495345053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biltmore-farms-llc",
      "poi_latitude": "35.4862453",
      "poi_longitude": "-82.5542718",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-209-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-f96d-7770-b6a9-7aaa09269654",
        "storage_key": "property/6767906449167904/01a1795e-f96d-7770-b6a9-7aaa09269654.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcy9-TbtWYgRnWUQUOBdxTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_abc1f9f1-bf94-4072-9e19-3b92471c6bba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Buncombe County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "60 Court Plaza, Asheville, NC 28801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-63c5-7738-83f9-5d70d71e5839.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-63c5-7738-83f9-5d70d71e5839",
        "storage_key": "property/6767906449167904/01a17965-63c5-7738-83f9-5d70d71e5839.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nccourts.gov/locations/buncombe-county/buncombe-county-courthouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=14773790175001522623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buncombe-county-courthouse",
      "poi_latitude": "35.5960579",
      "poi_longitude": "-82.5486299",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 828-259-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-dc4f-717e-b78f-abee1ae3f949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-dc4f-717e-b78f-abee1ae3f949",
        "storage_key": "property/6767906449167904/01a17965-dc4f-717e-b78f-abee1ae3f949.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8OpXljzWYgRvzEfp-MLB80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_dc8e6a6c-c986-48f9-aafa-a3105da13e49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "poi_name": "Asheville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Asheville, NC 28801, USA",
      "poi_short_description": "Government offices housed in a 1928 municipal building with art deco architectural features.",
      "poi_long_description": "Government offices housed in a 1928 municipal building with art deco architectural features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-5a79-7472-854e-9b6f6bbec4a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-5a79-7472-854e-9b6f6bbec4a6",
        "storage_key": "property/6767906449167904/01a17965-5a79-7472-854e-9b6f6bbec4a6.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://www.ashevillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6986768698202076768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asheville-city-hall",
      "poi_latitude": "35.5950438",
      "poi_longitude": "-82.54854309999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 828-251-1122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a17965-dc4f-717e-b78f-abee1ae3f949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-dc4f-717e-b78f-abee1ae3f949",
        "storage_key": "property/6767906449167904/01a17965-dc4f-717e-b78f-abee1ae3f949.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRmB-FjzWYgRYDYnEB399WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_efb16191d48d118494304328",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7eabda48fed88669d4cc2f50",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8a541579b4af74b6a4998a99",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c2cf4691ed16bf94ef3e09b4",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7772a45ff657865ef6e056db",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e7beff3f836430534536b164",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_d73d80cf6213b137bfb71314",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "day": "SUN",
      "open_time": "12:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_9be0aae6a068ea27bd3f3013",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "rating": "5",
      "name": "Chris M. Spears",
      "text": "From our very first visit last December, Ellison at the Preserve has been nothing short of spectacular. Our host Amy made the experience warm and welcoming from the moment we arrived — she set the tone for everything that followed.\n\nThe community itself is beautifully laid out, spacious, and has a genuine warmth to it that's hard to put into words but easy to feel. As a family navigating the process of getting our daughter settled for college in Asheville, we needed a place that felt right — not just on paper, but in person. Ellison made that decision easy.\n\nIf you're considering it, do yourself a favor and schedule a tour. The care the designers and staff have put into this place shows in every detail. You'll see it for yourself.\n\nHighly recommend.\n— Chris Spears",
      "date": "2026-06-10",
      "title": "false"
    },
    {
      "id": "ec_32ea1b9f12678286ae55013d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "rating": "5",
      "name": "Mackenzie Nabors",
      "text": "The property manager Ashleigh Schaub gave me and my partner a tour and we have never met anyone so friendly. She explained everything to us beautifully and made sure we understood the amenities and perks of living here. She was the best part of the tour!",
      "date": "2026-08-05",
      "title": "false"
    },
    {
      "id": "ec_20bd7ed73d8127eeb0ea6c9b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "rating": "5",
      "name": "Josue Urbaez",
      "text": "After nearly two months of living here, I can honestly say it’s been an amazing experience. The property staff are incredibly professional and welcoming it really feels like a community. Once the amenities are fully up and running, this place is going to be even better.\n\nThe gym is top-notch, and I can already tell the heated pool is going to be a huge hit, especially with spring here and summer just around the corner. The views from certain buildings are absolutely stunning I’m lucky enough to have a sunset balcony, and just sitting outside in the evenings, watching the sun go down, makes living here even more worth it.\n\nIf you’re considering moving in, I hope this review helps with your decision. This place truly stands out from the rest!",
      "date": "2025-03-18",
      "title": "false"
    },
    {
      "id": "ec_91bf168e30cb712b5ad83578",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "rating": "5",
      "name": "Paula Warren",
      "text": "I’ve been living here at Ellison since November. While there are so many things that are excellent here, the most impactful is the people who work here. They are all so kind, from Albert and Fred to all the girls in the front office area. But today, I’d like to give an extra shout out to Chloe. This woman is everywhere. No matter where you find her, she is always engaging with the residents, including the pets with a smile! She is always organizing and always present during the resident events. She is very hardworking and genuine. I’m sure she is worth every penny you pay her and then some! Hold on to her; she is a great ambassador for Ellison at the Preserves.",
      "date": "2026-03-15",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_430accb4-d65c-4e83-a8b1-3f5a18a55b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-eaed-715a-b37c-e9635d2f7f28.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-eaed-715a-b37c-e9635d2f7f28",
        "storage_key": "property/6767906449167904/01a1795f-eaed-715a-b37c-e9635d2f7f28.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 1208",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=xPu_DqLaHN"
    },
    {
      "id": "custom_b5a1a06c-a04c-4575-ba7e-3621ec3860bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-ef77-740c-949a-9838d084045b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-ef77-740c-949a-9838d084045b",
        "storage_key": "property/6767906449167904/01a1795f-ef77-740c-949a-9838d084045b.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 3414",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=SFI1jXgrcf"
    },
    {
      "id": "custom_80c1674d-c3d8-4f90-9282-1af38fca83b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-ebc0-759a-bca2-e69e0206df35.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-ebc0-759a-bca2-e69e0206df35",
        "storage_key": "property/6767906449167904/01a1795f-ebc0-759a-bca2-e69e0206df35.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 2411",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=9zDMkDVDFt"
    },
    {
      "id": "custom_3f35db1a-7fdf-40d7-a883-958e0ea90100",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-eb5f-75ac-86c9-2113997a5c7b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-eb5f-75ac-86c9-2113997a5c7b",
        "storage_key": "property/6767906449167904/01a1795f-eb5f-75ac-86c9-2113997a5c7b.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 3105",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=VuuDTshtmG"
    },
    {
      "id": "custom_342f463d-6000-4c7a-9273-71918ec90312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-eaf4-721f-9fb6-14b47f4b3fd9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-eaf4-721f-9fb6-14b47f4b3fd9",
        "storage_key": "property/6767906449167904/01a1795f-eaf4-721f-9fb6-14b47f4b3fd9.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 2410",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=UUk4a-ifqi"
    },
    {
      "id": "custom_f80fb8ac-a672-4b36-a3e2-e2886687a3d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-f834-779b-98a5-94b129e2b5d8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-f834-779b-98a5-94b129e2b5d8",
        "storage_key": "property/6767906449167904/01a1795f-f834-779b-98a5-94b129e2b5d8.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 1417",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=lxRsfkKPZm"
    },
    {
      "id": "custom_4d818f22-fa19-4f65-b51c-bf206a38d6cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-f7ce-7318-a0d6-ab584d4dfad7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-f7ce-7318-a0d6-ab584d4dfad7",
        "storage_key": "property/6767906449167904/01a1795f-f7ce-7318-a0d6-ab584d4dfad7.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 1419",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=QIYycFGaBd"
    },
    {
      "id": "custom_ab6f113e-269d-4437-9ebb-b5be983e2626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-f966-70ba-b044-fc3eaf26313f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-f966-70ba-b044-fc3eaf26313f",
        "storage_key": "property/6767906449167904/01a1795f-f966-70ba-b044-fc3eaf26313f.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 3319",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=CGD5dPQa65"
    },
    {
      "id": "custom_60144d33-6c54-4e82-aa73-9cbf0391b4c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-f899-7658-aae0-0f100cf2e1b9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-f899-7658-aae0-0f100cf2e1b9",
        "storage_key": "property/6767906449167904/01a1795f-f899-7658-aae0-0f100cf2e1b9.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 1410",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=780vnWz7Dh"
    },
    {
      "id": "custom_f8fdd137-6b59-40e2-999d-36b2c72e9f47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Ellison at The Preserve",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167904/01a1795f-f618-74b7-b94d-af0857483295.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1795f-f618-74b7-b94d-af0857483295",
        "storage_key": "property/6767906449167904/01a1795f-f618-74b7-b94d-af0857483295.webp",
        "width": 1179,
        "height": 1061
      },
      "virtual_tour_title": "Unit 1125",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://a.peek.us/viewer?token=g7RZPXFR3s"
    },
    {
      "id": "custom_0f3347dd-29de-4346-b13f-8f99f4ae29fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Interactive Floor Plan Tours",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://widgets.peek.us/propertyGrid?agent_id=68b99500f443d860264ff2bb"
    }
  ],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_b63f7f33276502a3ed4567a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "dogs:Dog",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 120,
      "deposit": 0,
      "fee": 500,
      "monthly_rent": 25,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_58d5f8f67874eb45c9e23970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "entrata",
      "external_id": "cats:Cat",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 50,
      "deposit": 0,
      "fee": 500,
      "monthly_rent": 25,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "pool-apartments-asheville-nc",
      "search_query": "pool apartments Asheville NC",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Asheville, NC",
      "h2_subtitle": "Discover the serenity of pool apartments in Asheville, NC. Enjoy modern amenities with breathtaking mountain views at Ellison at The Preserve.",
      "page_copy": "Experience the perfect blend of luxury and comfort at our pool apartments in Asheville, NC, where Ellison at The Preserve offers a refreshing lifestyle nestled against the stunning Blue Ridge backdrop. Dive into the inviting community pool after a day of exploring vibrant Asheville. \n\nEmbrace the convenience of resort-style amenities including EV charging stations and eat-in kitchens, all within your reach. Our open-concept floor plans range from studio to three-bedroom layouts, providing versatile living spaces enriched with modern features like pull-out sprayer faucets. Live at the heart of nature while enjoying the privileges of modern living at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Asheville, NC | Ellison Living",
      "seo_description": "Explore pool apartments in Asheville, NC at Ellison. Enjoy mountain views and modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-buncombe-county",
      "search_query": "pet friendly apartments in Buncombe County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Buncombe County",
      "h2_subtitle": "Explore pet-friendly apartments in Buncombe County. Enjoy luxurious living with your furry friends at Ellison at The Preserve.",
      "page_copy": "Find your perfect home at Ellison at The Preserve, offering pet-friendly apartments in Buncombe County where you and your furry companions can thrive. Set amidst the scenic beauty of the Blue Ridge, we provide open-concept studios to three-bedroom layouts that cater to all your elegant living needs.\n\nOur community features are designed with both pet and owner in mind. Take advantage of our expansive outdoor areas ideal for walks, and enjoy amenities such as a resident mail lounge and EV charging stations. All units come with modern conveniences, including kitchens equipped with sleek faucets featuring pull-out sprayers, ensuring a comfortable stay for every member of the household, human or pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Buncombe County",
      "seo_description": "Discover pet-friendly apartments in Buncombe County at Ellison. Luxurious living in a beautiful setting. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "luxury-apartments-washer-dryer-blue-ridge",
      "search_query": "luxury apartments with in unit washer dryer Blue Ridge",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Discover luxury apartments with in-unit washer dryer in Blue Ridge. Enjoy comfort and convenience at Ellison at The Preserve.",
      "page_copy": "Enjoy unparalleled comfort in our luxury apartments with in-unit washer dryer, located in the heart of Blue Ridge at Ellison at The Preserve. Our apartments are designed for those who appreciate the finer things in life, with spacious layouts ranging from studio to three-bedroom designs, all boasting elevated finishes and exceptional functionality.\n\nSet against the picturesque views of the Blue Ridge, these apartments redefine convenience. Alongside the in-unit laundry capabilities, residents enjoy amenities such as wheel-chair accessibility and resort-style comforts. Relax knowing that every detail, from modern faucets to EV charging stations, has been thoughtfully implemented for a seamless living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Washer Dryer in Blue Ridge",
      "seo_description": "Explore luxury living at Ellison in Blue Ridge with in-unit washer dryer. Experience convenience and mountain views. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-28803",
      "search_query": "air conditioned apartments near 28803",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 28803",
      "h2_subtitle": "Find air conditioned apartments near 28803 with modern comforts. Experience luxury living at Ellison at The Preserve.",
      "page_copy": "Stay cool and comfortable in our air conditioned apartments near 28803, designed to offer a blend of luxury and convenience at Ellison at The Preserve. Nestled in Asheville's scenic Blue Ridge area, our community provides open-concept living spaces ranging from studio to three-bedroom apartments, each thoughtfully designed with air conditioning to ensure optimal comfort year-round.\n\nExperience contemporary living with our array of amenities including eat-in kitchens, a modern resident mail lounge, and private package rooms. Beyond the interiors, enjoy beautifully maintained outdoor spaces and community perks like EV charging stations, making Ellison at The Preserve an idyllic choice for refined living near 28803.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 28803",
      "seo_description": "Discover air conditioned apartments near 28803 at Ellison. Enjoy modern amenities and scenic views. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-modern-kitchen-asheville",
      "search_query": "apartments with dishwasher and modern kitchen Asheville",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher and Modern Kitchen",
      "h2_subtitle": "Explore apartments with dishwasher and modern kitchen in Asheville. Experience contemporary design at Ellison at The Preserve.",
      "page_copy": "Discover the perfect blend of style and functionality in our apartments with dishwasher and modern kitchen in Asheville. Ellison at The Preserve offers meticulously designed living spaces that cater to your culinary desires, with kitchens featuring cutting-edge appliances, including convenient dishwashers and faucets with pull-out sprayers.\n\nNestled in the Blue Ridge neighborhood, our community provides more than just a place to live. Enjoy the beauty of our open-concept layouts, ranging from studios to spacious three-bedroom homes. Enhance your living experience with community amenities like EV charging stations and a private package room, ensuring every convenience is within reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher & Modern Kitchen Asheville",
      "seo_description": "Find apartments with dishwasher and modern kitchen in Asheville at Ellison. Modern living with top amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "studio-apartments-asheville-nc",
      "search_query": "studio apartments asheville nc",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Asheville, NC",
      "h2_subtitle": "Discover studio apartments in Asheville, NC at Ellison at The Preserve. Enjoy modern living with breathtaking mountain views.",
      "page_copy": "Experience the perfect balance of style and efficiency in our studio apartments in Asheville, NC. Ellison at The Preserve offers thoughtfully designed studio spaces that maximize comfort and functionality, making them the ideal choice for modern living.\n\nLocated in the serene Blue Ridge area, our community promises a lifestyle enriched by stunning mountain views and state-of-the-art amenities. Each studio enjoys access to features like an eat-in kitchen and high-end fixtures, while the community offers perks such as a resident mail lounge and private package room. Enjoy the beauty and convenience of Asheville living at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Asheville, NC",
      "seo_description": "Explore studio apartments in Asheville, NC at Ellison. Modern design and mountain views. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-blue-ridge",
      "search_query": "one bedroom apartments blue ridge",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Blue Ridge",
      "h2_subtitle": "Explore one bedroom apartments in Blue Ridge at Ellison. Experience comfort and convenience in a stunning location.",
      "page_copy": "Discover the comfort and elegance of our one bedroom apartments in Blue Ridge, perfectly crafted for those seeking a sophisticated living experience. At Ellison at The Preserve, each apartment embodies contemporary design with features that elevate everyday convenience, such as expansive living spaces and premium finishes.\n\nSituated in picturesque Blue Ridge, residents enjoy easy access to Asheville's vibrant offerings while relishing community amenities like EV charging stations and wheelchair accessibility. With a modern eat-in kitchen and scenic views, these one bedroom residences are designed to cater to every lifestyle need, making Ellison at The Preserve a top choice for discerning renters.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Blue Ridge",
      "seo_description": "Find one bedroom apartments in Blue Ridge at Ellison. Modern amenities and stunning design. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-buncombe-county",
      "search_query": "two bedroom apartments buncombe county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Buncombe County",
      "h2_subtitle": "Discover two bedroom apartments in Buncombe County at Ellison. Enjoy spacious living in a beautiful mountain setting.",
      "page_copy": "Ellison at The Preserve offers exceptional two bedroom apartments in Buncombe County designed for vibrant lifestyles and modern convenience. Each apartment provides spacious layouts with premium fixtures, creating a perfect home base in the serene surroundings of Asheville's Blue Ridge neighborhood.\n\nIndulge in the luxury of a contemporary eat-in kitchen, complete with modern faucets and full appliance packages, while taking in the breathtaking views. Our community ensures residents enjoy exclusive amenities like EV charging stations and a private package room. Choose Ellison at The Preserve for a refined living experience in Buncombe County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Buncombe County",
      "seo_description": "Explore two bedroom apartments in Buncombe County at Ellison. Spacious, modern living with top amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-28803",
      "search_query": "three bedroom apartments near 28803",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 28803",
      "h2_subtitle": "Explore three bedroom apartments near 28803 at Ellison. Spacious designs and luxurious finishes await.",
      "page_copy": "For those seeking expansive living spaces, Ellison at The Preserve offers exceptional three bedroom apartments near the 28803 area. Each unit is meticulously designed, ensuring comfort with open concept layouts, modern finishes, and an abundance of natural light.\n\nNestled in the scenic Blue Ridge area of Asheville, our community combines the tranquility of mountain views with the convenience of nearby urban amenities. Enjoy a modern eat-in kitchen, perfect for culinary adventures, and unwind in a resort-style setting with unique community features, including EV charging stations. Experience ultimate living at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 28803",
      "seo_description": "Discover three bedroom apartments near 28803 at Ellison. Enjoy spacious living and premium amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-near-charles-t-koontz-intermediate-school",
      "search_query": "apartments near Charles T. Koontz Intermediate School Asheville",
      "category": "School",
      "h1_title": "Apartments Near Koontz Intermediate School",
      "h2_subtitle": "Find apartments near Charles T. Koontz Intermediate School. Enjoy modern living in the sought-after Asheville area.",
      "page_copy": "Ellison at The Preserve offers exceptional apartment living near Charles T. Koontz Intermediate School in Asheville. Our community features thoughtfully designed studio, one, two, and three-bedroom apartments, perfect for families and professionals seeking convenience and style.\n\nLocated in the Blue Ridge neighborhood, residents enjoy close proximity to top-rated schools and urban amenities. Each apartment comes with standout features like a modern eat-in kitchen, scenic outdoor spaces, and resort-style community perks such as EV charging stations. Choose Ellison at The Preserve for unparalleled comfort and accessibility near educational excellence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Koontz Intermediate School",
      "seo_description": "Discover modern apartments near Charles T. Koontz Intermediate School in Asheville. Ideal location with top amenities. Visit Ellison today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-close-to-william-w-estes-elementary-school",
      "search_query": "apartments close to William W. Estes Elementary School Blue Ridge",
      "category": "School",
      "h1_title": "Apartments Close to Estes Elementary School",
      "h2_subtitle": "Explore apartments close to William W. Estes Elementary School. Located in the beautiful Blue Ridge area of Asheville.",
      "page_copy": "Situated in Asheville's picturesque Blue Ridge neighborhood, Ellison at The Preserve provides ideal apartment living close to William W. Estes Elementary School. Our community features a range of studio to three-bedroom apartments, tailored for families and individuals seeking both comfort and convenience.\n\nExperience contemporary living with amenities like an eat-in kitchen, resident mail lounge, and private package room. Nestled in a lush mountain setting, our community also includes EV charging stations, ensuring an eco-friendly lifestyle. Choose Ellison at The Preserve for prime access to education while enjoying a blend of tranquility and modernity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Estes Elementary School",
      "seo_description": "Find spacious apartments near William W. Estes Elementary in Blue Ridge, Asheville. Comfort and convenience await at Ellison. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "ellison-preserve-apartments-tc-roberson-high-school",
      "search_query": "Ellison at The Preserve apartments T.C. Roberson High School",
      "category": "School",
      "h1_title": "Ellison Apartments Near T.C. Roberson High",
      "h2_subtitle": "Discover living at Ellison at The Preserve, conveniently close to T.C. Roberson High School. Experience luxury and convenience in Asheville.",
      "page_copy": "Located in Asheville's Blue Ridge area, Ellison at The Preserve offers luxury living near T.C. Roberson High School. Our community is perfect for those who value a blend of modern amenities and proximity to schools.\n\nChoose from a variety of apartment layouts, each featuring open-concept designs, modern faucets, and a cozy eat-in kitchen. Enjoy community perks such as a resident mail lounge and EV charging stations. With beautiful mountain views and a convenient location, Ellison at The Preserve combines the best of comfort and accessibility, ideal for students and families alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ellison Apartments Near T.C. Roberson High",
      "seo_description": "Live at Ellison at The Preserve, close to T.C. Roberson High. Luxury apartments in Asheville with top-notch amenities. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "asheville-multifamily-properties-valley-springs",
      "search_query": "Ashville multifamily properties near Valley Springs Middle School",
      "category": "School",
      "h1_title": "Asheville Apartments by Valley Springs Middle",
      "h2_subtitle": "Find Asheville multifamily properties near Valley Springs Middle School. Experience community living with premium features.",
      "page_copy": "Ellison at The Preserve stands out among Asheville's multifamily properties, ideally located near Valley Springs Middle School. Our community provides a perfect blend of modern living and convenience, offering a variety of apartment styles, from spacious studios to three-bedroom options.\n\nResidents benefit from elegant apartment features, such as eat-in kitchens and contemporary faucets with pull-out sprayers. The community also boasts EV charging stations and scenic outdoor areas. Situated in the desirable Blue Ridge area, Ellison at The Preserve provides easy access to outstanding educational institutions and serene mountain views, making it an ideal home base for families and educators.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Asheville Apartments by Valley Springs Middle",
      "seo_description": "Explore Ellison at The Preserve – multifamily living near Valley Springs Middle in Asheville. Premium amenities in a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "buncombe-apartments-near-ab-tech",
      "search_query": "Buncombe County apartments near Asheville-Buncombe Technical Community College",
      "category": "School",
      "h1_title": "Buncombe Apartments Near AB Tech",
      "h2_subtitle": "Discover Buncombe County apartments near Asheville-Buncombe Technical Community College. Enjoy a convenient and enriching lifestyle.",
      "page_copy": "Ellison at The Preserve offers an ideal location for students and faculty of Asheville-Buncombe Technical Community College. Situated in the picturesque Blue Ridge neighborhood, our community features a variety of spacious living options, from studios to three-bedroom apartments, perfect for anyone seeking a balance of comfort and accessibility.\n\nResidents benefit from upscale amenities including modern eat-in kitchens, a private package room, and EV charging stations. The property's proximity to AB Tech ensures that commuting is a breeze, allowing more time to enjoy the serene outdoor spaces and resort-style comforts of home. Experience a vibrant community lifestyle at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Buncombe Apartments Near AB Tech",
      "seo_description": "Find Ellison at The Preserve nearby AB Tech in Buncombe County, offering convenience and modern amenities. Ideal for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "ellison-preserve-near-university-nc-asheville",
      "search_query": "Ellison at The Preserve near University of North Carolina Asheville",
      "category": "School",
      "h1_title": "Ellison Apartments by UNC Asheville",
      "h2_subtitle": "Explore Ellison at The Preserve, conveniently located near the University of North Carolina Asheville. Enjoy unmatched living in a scenic setting.",
      "page_copy": "Nestled in Buncombe County's Blue Ridge area, Ellison at The Preserve is the ideal choice for anyone affiliated with the University of North Carolina Asheville. Our stylish community offers a selection of open-concept studio to three-bedroom apartments, each designed with modern comforts in mind.\n\nEnjoy luxury features such as sleek eat-in kitchens and contemporary faucets. The community also offers practical amenities, including EV charging stations and a resident mail lounge. Experience the perfect balance of convenience and relaxation with close proximity to UNC Asheville and stunning mountain views, making it an exceptional place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ellison Apartments by UNC Asheville",
      "seo_description": "Live at Ellison at The Preserve, near UNC Asheville. Enjoy modern apartment living with top-tier amenities and stunning mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-near-carolina-day-school-asheville",
      "search_query": "apartments near Carolina Day School in Asheville NC",
      "category": "School",
      "h1_title": "Apartments Near Carolina Day School, NC",
      "h2_subtitle": "Find exceptional apartments near Carolina Day School in Asheville. Enjoy family-friendly living with premium community features.",
      "page_copy": "Ellison at The Preserve presents an ideal living environment for families seeking proximity to Carolina Day School in Asheville, NC. Situated in the serene Blue Ridge neighborhood, our community offers a variety of luxurious apartment options, ranging from studio to three-bedroom layouts, designed to meet diverse lifestyle needs.\n\nResidents enjoy outstanding amenities such as eat-in kitchens, modern faucets, and convenient EV charging stations. With resort-style features and scenic outdoor spaces, Ellison at The Preserve ensures a comfortable and connected living environment, just a short drive from the acclaimed Carolina Day School. Discover the blend of accessibility and elegance today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Carolina Day School, NC",
      "seo_description": "Discover Ellison at The Preserve – Luxury apartment living near Carolina Day School in Asheville, offering modern amenities and family-friendly community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-near-mission-hospital-asheville",
      "search_query": "apartments near mission hospital asheville",
      "category": "Hospital",
      "h1_title": "Apartments Near Mission Hospital Asheville",
      "h2_subtitle": "Explore exquisite apartments near Mission Hospital in Asheville. Enjoy easy access to healthcare and luxurious community amenities.",
      "page_copy": "Ellison at The Preserve offers a premier living experience ideal for healthcare professionals and families needing quick access to Mission Hospital in Asheville. Located in the tranquil Blue Ridge neighborhood, our community features spacious studio to three-bedroom apartments with upscale finishes designed for comfort and style.\n\nResidents can take advantage of modern conveniences such as EV charging stations, eat-in kitchens, and a private package room. The community's location provides a peaceful retreat, while still offering easy commutes to Mission Hospital. Embrace a lifestyle of convenience and elegance at Ellison at The Preserve, where mountain views and top-tier amenities await.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mission Hospital Asheville",
      "seo_description": "Live near Mission Hospital Asheville at Ellison at The Preserve. Experience convenience and luxury with modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-close-charles-george-va-medical-center",
      "search_query": "apartments close to charles george va medical center blue ridge",
      "category": "Hospital",
      "h1_title": "Apartments Near Charles George VA Center",
      "h2_subtitle": "Find comfortable apartments close to Charles George VA Medical Center in Blue Ridge. Enjoy a convenient and serene lifestyle.",
      "page_copy": "Ellison at The Preserve is designed for those seeking a premium living experience near Charles George VA Medical Center in the charming Blue Ridge area. Offering a variety of spacious studio to three-bedroom apartments, our community ensures comfort with its refined finishes.\n\nResidents can enjoy an array of amenities including EV charging stations, modern kitchens with pull-out sprayers, and a resident mail lounge. Whether you're a medical professional or seeking proximity for healthcare, our location provides the perfect balance of accessibility and tranquility. Experience mountain-view living with convenience at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charles George VA Center",
      "seo_description": "Choose Ellison at The Preserve for mountain-view living close to Charles George VA Medical Center with modern amenities and easy access in Blue Ridge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "ellison-preserve-near-corcoran-paige-river-park",
      "search_query": "ellison at the preserve near corcoran paige river park",
      "category": "Park",
      "h1_title": "Ellison at The Preserve Near Corcoran Paige",
      "h2_subtitle": "Discover Ellison at The Preserve, located near Corcoran Paige River Park. Enjoy luxury living with stunning mountain views and refined features.",
      "page_copy": "Ellison at The Preserve is located just a short distance from the scenic Corcoran Paige River Park, offering residents a peaceful and invigorating environment. Our community in Blue Ridge provides a perfect blend of luxury and location, with studio to three-bedroom apartments that boast contemporary finishes and generous layouts.\n\nResidents enjoy resort-inspired amenities such as EV charging stations, a resident mail lounge, and stylish eat-in kitchens. Living near Corcoran Paige River Park means easy access to outdoor adventures and relaxation, while savoring the comforts of modern living at Ellison at The Preserve. Embrace the tranquility and elegance of mountain-view living today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ellison at The Preserve near Corcoran Paige",
      "seo_description": "Live at Ellison at The Preserve, near Corcoran Paige River Park. Experience luxury apartments with modern features and convenient access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "apartments-glen-bridge-river-park-asheville",
      "search_query": "apartments by glen bridge river park asheville",
      "category": "Park",
      "h1_title": "Apartments by Glen Bridge River Park",
      "h2_subtitle": "Explore apartments by Glen Bridge River Park in Asheville. Enjoy premium living with access to beautiful parks and top-notch amenities.",
      "page_copy": "Ellison at The Preserve offers a unique living experience nestled near Glen Bridge River Park in Asheville. Perfect for nature lovers and those who cherish serene surroundings, our community combines elegance with convenience, providing open-concept studio to three-bedroom apartments with sophisticated interiors.\n\nHere, residents benefit from amenities like EV charging stations and eat-in kitchens, along with the peace of living near beautiful parkland. Whether you enjoy hiking, picnicking, or simply being outdoors, living at Ellison ensures you're steps away from your next adventure at Glen Bridge River Park, coupled with the convenience of modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Glen Bridge River Park",
      "seo_description": "Discover Ellison at The Preserve near Glen Bridge River Park. Luxury apartments offer scenic views and premium amenities close to Asheville's natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "living-near-bent-creek-river-park-blue-ridge",
      "search_query": "living near bent creek river park blue ridge",
      "category": "Park",
      "h1_title": "Living Near Bent Creek River Park",
      "h2_subtitle": "Experience living near Bent Creek River Park in Blue Ridge. Enjoy luxurious apartment features and stunning natural surroundings.",
      "page_copy": "Nestled near the picturesque Bent Creek River Park in Blue Ridge, Ellison at The Preserve offers a refined living experience amidst nature's beauty. Our community is the ideal choice for those seeking a harmonious blend of outdoor adventures and modern comforts in one location.\n\nWith spacious studio to three-bedroom floor plans, residents can relish top-quality amenities like EV charging stations and stylish kitchens. Proximity to Bent Creek River Park means you can effortlessly transition from urban relaxation to immersing yourself in the scenic landscapes and trails nearby. Discover the best of both worlds at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Bent Creek River Park",
      "seo_description": "Enjoy living near Bent Creek River Park at Ellison in Blue Ridge. Discover luxury apartments with modern amenities and natural beauty at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "close-to-north-carolina-arboretum-buncombe-county",
      "search_query": "close to the north carolina arboretum in buncombe county",
      "category": "Park",
      "h1_title": "Close to the North Carolina Arboretum",
      "h2_subtitle": "Live close to the North Carolina Arboretum in Buncombe County. Experience luxury apartments with excellent amenities and beautiful views.",
      "page_copy": "Ellison at The Preserve provides an exceptional opportunity to live close to the renowned North Carolina Arboretum in Buncombe County. Our serene community offers residents the perfect balance between nature and luxury, featuring studio to three-bedroom apartments with upscale finishes and enticing views.\n\nResidents enjoy unparalleled amenities, including EV charging stations and modern kitchens, while the proximity to the North Carolina Arboretum offers easy access to lush gardens and scenic trails. Embrace nature and elegance combined at Ellison - the perfect home for those who value both comfort and outdoor leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close to the North Carolina Arboretum",
      "seo_description": "Live at Ellison near the North Carolina Arboretum in Buncombe County. Enjoy luxurious apartment living with nature's beauty all around.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167904",
      "source": "generator",
      "page_item_url": "kenilworth-park-apartments-asheville-nc",
      "search_query": "kenilworth park apartments asheville nc",
      "category": "Park",
      "h1_title": "Kenilworth Park Apartments in Asheville",
      "h2_subtitle": "Discover Kenilworth Park apartments in Asheville, NC. Enjoy upscale living with convenient amenities and proximity to local attractions.",
      "page_copy": "Ellison at The Preserve is ideally located near Kenilworth Park, offering residents the charm of Asheville living with modern apartment luxuries. Our community provides spacious studio to three-bedroom apartments featuring elevated finishes perfect for a stylish lifestyle while enjoying nearby recreational spaces.\n\nResidents benefit from exclusive amenities such as EV charging stations and eat-in kitchens, all within easy reach of Kenilworth Park. Here, you can engage in outdoor activities or simply relax in a vibrant community atmosphere. Live in comfort and connect with the essence of Asheville at Ellison at The Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with coffee bar and view of outdoor pool",
        "public_id": "01a17961-d1e9-7528-bfbd-000f650baa60",
        "storage_key": "property/6767906449167904/01a17961-d1e9-7528-bfbd-000f650baa60.webp",
        "width": 719,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kenilworth Park Apartments Asheville, NC",
      "seo_description": "Explore luxury living at Ellison near Kenilworth Park in Asheville, NC. Enjoy modern amenities and the vibrant surroundings of this beautiful location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13387211485"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yzvgx726wln"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_nurture_boss_scheduler_url",
      "type": "STRING",
      "value": "https://www.theonsiteteam.com/schedule-tour?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWM1MzU5MDc3YzgyODAwMDQzMDMzYjYiLCJwcm9wZXJ0eU5hbWUiOiJFbGxpc29uIGF0IHRoZSBQcmVzZXJ2ZSIsImlhdCI6MTc5MzA0OTY2NH0.CSt-WtyRGyDT21-E3P2LjEYe9OHWswSsGZjRtrBJZuY"
    },
    {
      "ID": "custom_nurture_boss_chatbot_script",
      "type": "STRING",
      "value": "<script defer src=\"https://widget.nurtureboss.io/widget.js\" id=\"nb-widget-script\" data-token=\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWM1MzU5MDc3YzgyODAwMDQzMDMzYjYiLCJwcm9wZXJ0eU5hbWUiOiJFbGxpc29uIGF0IHRoZSBQcmVzZXJ2ZSIsImlhdCI6MTc5MzA0OTY2NH0.CSt-WtyRGyDT21-E3P2LjEYe9OHWswSsGZjRtrBJZuY\"></script>"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "13387211485",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yzvgx726wln",
  "custom_website_subscription": "turnkey",
  "custom_nurture_boss_scheduler_url": "https://www.theonsiteteam.com/schedule-tour?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWM1MzU5MDc3YzgyODAwMDQzMDMzYjYiLCJwcm9wZXJ0eU5hbWUiOiJFbGxpc29uIGF0IHRoZSBQcmVzZXJ2ZSIsImlhdCI6MTc5MzA0OTY2NH0.CSt-WtyRGyDT21-E3P2LjEYe9OHWswSsGZjRtrBJZuY",
  "custom_nurture_boss_chatbot_script": "<script defer src=\"https://widget.nurtureboss.io/widget.js\" id=\"nb-widget-script\" data-token=\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWM1MzU5MDc3YzgyODAwMDQzMDMzYjYiLCJwcm9wZXJ0eU5hbWUiOiJFbGxpc29uIGF0IHRoZSBQcmVzZXJ2ZSIsImlhdCI6MTc5MzA0OTY2NH0.CSt-WtyRGyDT21-E3P2LjEYe9OHWswSsGZjRtrBJZuY\"></script>",
  "custom_audioeye_site_id": "5a404676-e202-4b27-a3a4-2cdbb51c2f4d",
  "custom_audioeye_site_hash": "f4efda8b78be1a8205a77606aa8e889b"
};

export const generatedAt = '2026-11-05T18:34:39.025Z';
